<template>
    <div class="sales-lead-page">
        <Breadcrumbs v-if="!simulatedSupplier" main="" :title="this.$t('lbl_EMPBE_SalesLead_SalesLead')" />
        <EmpExportInfoModal
            modal-id="sales-lead-export-limit-modal"
            v-model="exportLimitModalVisible"
            :title="$t('lbl_EMPBE_SalesLead_Export_LimitTitle')"
            :subtitle="exportLimitModalSubtitle"
            :ok-text="$t('lbl_EMPBE_SalesLead_Export_ModalOk')"
        />
        <EmpExportInfoModal
            modal-id="sales-lead-export-queue-modal"
            v-model="exportQueueModalVisible"
            :title="$t('lbl_EMPBE_SalesLead_Export_QueueTitle')"
            :subtitle="$t('lbl_EMPBE_SalesLead_Export_QueueSubtitle')"
            :ok-text="$t('lbl_EMPBE_SalesLead_Export_ModalOk')"
        />
        <SalesLeadExportModal
            v-model="exportModalVisible"
            :export-title="exportModalTitle"
            :export-all-option-label="exportAllOptionLabel"
            :exporting="exporting"
            :allow-csv="!IsAll"
            @export="onExportConfirm"
        />
        <div class="container-fluid">
            <div :class="['sales-lead', { 'sales-lead--embedded': !!simulatedSupplier }]">
                <div class="sales-lead-left">
                    <div class="leftmenu">
                                <div class="header">
                                    <div class="header-title-row">
                                        <span class="title">{{ $t('lbl_EMPBE_SalesLead_SalesLead') }}</span>
                                        <button
                                            type="button"
                                            class="main-tabs-swipe-hint"
                                            @click="scrollMainTabsRight"
                                            :aria-label="$t('lbl_EMPBE_SalesLead_MainTabs_SwipeForMore')"
                                            t_label="Emp_saleslead_main_tabs_swipe_more"
                                        >
                                            <span class="main-tabs-swipe-hint__text">{{ $t('lbl_EMPBE_SalesLead_MainTabs_SwipeForMore') }}</span>
                                            <svg class="main-tabs-swipe-hint__icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                                <path d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z" fill="currentColor" fill-opacity="0.55"/>
                                            </svg>
                                        </button>
                                    </div>
                                    <!-- 顶部主 Tab：Swiper + navigation（对齐 BuyerHeader_IndustryNews：悬浮圆形箭头 + Swiper navigation） -->
                                    <div class="main-tabs-slider-wrap">
                                    <swiper ref="mainTabsSwiper" class="tab-container main-tabs-swiper" :options="mainTabsSwiperOptions">
                                        <swiper-slide v-for="(item, index) in SalesLeadsTypeData" :key="item.id">
                                                <a href="javascript:void(0)"
                                                   @click="ChangeMainTab(index)"
                                                   v-bind:t_label="`Emp_saleslead_${item.id}`">
                                                    <div :class="`current-tab ${SalesLeadsType == index ? 'bg-Blur' : 'bg-white'}`">
                                                        <div class="current-tab-inner">
                                                        <img v-if="item.tabIcon && item.id !== 'all'" class="main-tab-icon" :src="mainTabIconSrc(item, index)" alt="" width="16" height="16" />
                                                        <span :class="`${SalesLeadsType == index ? 'current-tab-inner-white' : 'current-tab-inner-black'}`">
                                                            {{ item.label }}
                                                        </span>
                                                        <div v-if="item.Nums > 0"
                                                             :class="`unread-num ${SalesLeadsType == index ? 'bg-white Text-Blur' : 'bg-Blur Text-white'}`">
                                                            {{ item.Nums }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </swiper-slide>
                                    </swiper>
                                        <div
                                            ref="slMainTabsNavPrev"
                                            class="swiper-button-prev sl-main-tabs-nav-btn sl-main-tabs-nav-btn--prev"
                                            role="button"
                                            tabindex="0"
                                            :aria-label="$t('lbl_EMPBE_SalesLead_MainTabs_ScrollLeft')"
                                        >
                                            <img src="https://cdn.adsalecdn.com/EMP/2-0/BuyerIdx/BuyerIdx_prev_Left.svg" alt="" />
                                        </div>
                                        <div
                                            ref="slMainTabsNavNext"
                                            class="swiper-button-next sl-main-tabs-nav-btn sl-main-tabs-nav-btn--next"
                                            role="button"
                                            tabindex="0"
                                            :aria-label="$t('lbl_EMPBE_SalesLead_MainTabs_ScrollRight')"
                                        >
                                            <img src="https://cdn.adsalecdn.com/EMP/2-0/BuyerIdx/BuyerIdx_next_right.svg" alt="" />
                                        </div>
                                    </div>
                                                    </div>
                                <SalesLeadToolbar
                                    :keyword.sync="keyword"
                                    :read-filter="readFilter"
                                    @search="search"
                                    @clear-search="clear"
                                    @read-filter-change="onReadFilterChange"
                                    @open-export="openExportModal"
                                />
                                <div class="tab-container" v-if="GetSearchbarNavTab.length > 0 && !IsAll">
                                   <router-link 
                                    v-if="!simulatedSupplier"
                                    v-for="(item, index) in GetSearchbarNavTab" 
                                    :key="item.id"
                                    :to="!simulatedSupplier ? { path: '/salesLead/' + item.router } : ''"
                                    custom v-slot="{ navigate }"
                                    >
                                        <a href="javascript:void(0)"
                                        :t_label="`Emp_saleslead_Nav_${item.id}`"
                                        @click="ChangeSearchTab(index)"
                                        >

                                            <div :class="`current-tab ${NavTabIndex == index ? 'bg-Blur' : 'bg-white'}`">
                                                <div class="current-tab-inner">
                                                    <span :class="`${NavTabIndex == index ? 'current-tab-inner-white' : 'current-tab-inner-black'}`">
                                                        {{ item.label }}
                                                    </span>
                                                    <div 
                                                        v-if="item.Nums > 0" 
                                                        :class="`unread-num ${NavTabIndex == index ? 'bg-white Text-Blur' : 'bg-Blur Text-white'}`"
                                                    >
                                                        {{ item.Nums }}
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                   </router-link>

                                   <a v-if="simulatedSupplier"
                                   v-for="(item, index) in GetSearchbarNavTab" 
                                   :key="item.id"
                                   @click="ChangeSearchTab(index)"
                                   :t_label="`Emp_saleslead_Nav_${item.id}`"
                                   >
                                        <div :class="`current-tab ${NavTabIndex == index ? 'bg-Blur' : 'bg-white'}`">
                                            <div class="current-tab-inner">
                                                <span :class="`${NavTabIndex == index ? 'current-tab-inner-white' : 'current-tab-inner-black'}`">
                                                    {{ item.label }}
                                                </span>
                                                <div 
                                                    v-if="item.Nums > 0" 
                                                    :class="`unread-num ${NavTabIndex == index ? 'bg-white Text-Blur' : 'bg-Blur Text-white'}`"
                                                >
                                                    {{ item.Nums }}
                                                </div>
                                            </div>
                                        </div>
                                   </a>



                                    <!--
                                    <component 
                                        :is="!simulatedSupplier ? 'router-link' : 'a'"
                                        v-for="(item, index) in GetSearchbarNavTab" 
                                        :key="item.id"
                                        :to="!simulatedSupplier ? { path: '/salesLead/' + item.router } : ''"
                                        :t_label="`Emp_saleslead_Nav_${item.id}`"
                                        @click="ChangeSearchTab(index)"
                                    >
                                        <div :class="`current-tab ${NavTabIndex == index ? 'bg-Blur' : 'bg-white'}`">
                                            <div class="current-tab-inner">
                                                <span :class="`${NavTabIndex == index ? 'current-tab-inner-white' : 'current-tab-inner-black'}`">
                                                    {{ item.label }}
                                                </span>
                                                <div 
                                                    v-if="item.Nums > 0" 
                                                    :class="`unread-num ${NavTabIndex == index ? 'bg-white Text-Blur' : 'bg-Blur Text-white'}`"
                                                >
                                                    {{ item.Nums }}
                                                </div>
                                            </div>
                                        </div>
                                    </component>-->
                                </div>
                                <div class="leftmenu__body-scroll">
                                <div class="OnlyShowRepyto" v-if="IsRepyTo && !isEmpty && !loading">
                                    {{ $t('lbl_EMPBE_SalesLead_OnlyShowedHere') }}
                                </div>
                                <div class="SalesLeadFreeGuota" v-if="!loading && !isEmpty && (IsInquiry || IsNameCard || IsLikeFollow) && IsNonPaidBooth">
                                    <unlockQuota_Free
                                        v-if="refreshUnlockQuota"
                                        Type="1"
                                        :unlockType="IsNameCard ? 'NameCard' : (IsLikeFollow ? 'Bookmark' : 'Enquiry')"
                                        :user="user"
                                        :rid="activeId"
                                    ></unlockQuota_Free>
                                </div>
                                <SalesLeadListSkeleton v-if="loading" class="leftmenu__skeleton" />
                                <div v-else class="leftmenu__list-host" :class="{ 'leftmenu__list-host--refreshing': listRefreshing }">
                                <SalesLeadListSkeleton v-if="listRefreshing" class="leftmenu__skeleton leftmenu__skeleton--overlay" />
                                <!-- Name Card empty state (Figma node 3133:26197) -->
                                <div class="nc-empty" v-if="IsNameCard && isEmpty && !listRefreshing">
                                    <i class="nc-empty-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 96 96" fill="none">
                                            <path d="M56 52H76V44H56V52ZM56 40H76V32H56V40ZM20 64H52V61.8C52 58.8 50.5333 56.4167 47.6 54.65C44.6667 52.8833 40.8 52 36 52C31.2 52 27.3333 52.8833 24.4 54.65C21.4667 56.4167 20 58.8 20 61.8V64ZM36 48C38.2 48 40.0833 47.2167 41.65 45.65C43.2167 44.0833 44 42.2 44 40C44 37.8 43.2167 35.9167 41.65 34.35C40.0833 32.7833 38.2 32 36 32C33.8 32 31.9167 32.7833 30.35 34.35C28.7833 35.9167 28 37.8 28 40C28 42.2 28.7833 44.0833 30.35 45.65C31.9167 47.2167 33.8 48 36 48ZM16 80C13.8 80 11.9167 79.2167 10.35 77.65C8.78333 76.0833 8 74.2 8 72V24C8 21.8 8.78333 19.9167 10.35 18.35C11.9167 16.7833 13.8 16 16 16H80C82.2 16 84.0833 16.7833 85.65 18.35C87.2167 19.9167 88 21.8 88 24V72C88 74.2 87.2167 76.0833 85.65 77.65C84.0833 79.2167 82.2 80 80 80H16ZM16 72H80V24H16V72Z" fill="black" fill-opacity="0.2"/>
                                        </svg>
                                    </i>
                                    <span class="nc-empty-text">{{ $t('lbl_EMPBE_SalesLead_NoCardsReceivedYet') }}</span>
                                </div>
                                <div class="no-enquiry" v-else-if="!searched && isEmpty && !listRefreshing">
                                    <div class="upper">
                                        <div class="no-enquiry-svg-container">
                                            <i class="no-search-result-svg">
                                                <svg v-if="IsMathed" xmlns="http://www.w3.org/2000/svg" width="57"
                                                    height="52" viewBox="0 0 57 52" fill="none">
                                                    <path
                                                        d="M37.6668 5.41399H5.66683V38.0007H23.6668V43.334H5.66683C2.7335 43.334 0.333496 40.934 0.333496 38.0007V6.00065C0.333496 3.06732 2.7335 0.667316 5.66683 0.667316H37.6668C40.6002 0.667316 43.0002 3.06732 43.0002 6.00065V24.6673H37.6668V5.41399Z"
                                                        fill="black" fill-opacity="0.2" />
                                                    <path
                                                        d="M34.0337 42.724C29.8997 42.724 21.667 44.791 21.667 48.9073V51.999H46.4003V48.9073C46.4003 44.791 38.1677 42.724 34.0337 42.724ZM25.801 48.4656C27.285 47.441 30.8713 46.2573 34.0337 46.2573C37.196 46.2573 40.7823 47.441 42.2663 48.4656H25.801ZM34.0337 39.6323C37.4433 39.6323 40.217 36.8586 40.217 33.449C40.217 30.0393 37.4433 27.2656 34.0337 27.2656C30.624 27.2656 27.8503 30.0393 27.8503 33.449C27.8503 36.8586 30.624 39.6323 34.0337 39.6323ZM34.0337 30.799C35.5 30.799 36.6837 31.9826 36.6837 33.449C36.6837 34.9153 35.5 36.099 34.0337 36.099C32.5673 36.099 31.3837 34.9153 31.3837 33.449C31.3837 31.9826 32.5673 30.799 34.0337 30.799ZM46.471 42.83C48.5203 44.314 49.9337 46.2926 49.9337 48.9073V51.999H57.0003V48.9073C57.0003 45.3386 50.817 43.307 46.471 42.83ZM44.6337 39.6323C48.0433 39.6323 50.817 36.8586 50.817 33.449C50.817 30.0393 48.0433 27.2656 44.6337 27.2656C43.6797 27.2656 42.7963 27.4953 41.9837 27.884C43.0967 29.4563 43.7503 31.382 43.7503 33.449C43.7503 35.516 43.0967 37.4416 41.9837 39.014C42.7963 39.4026 43.6797 39.6323 44.6337 39.6323Z"
                                                        fill="black" fill-opacity="0.2" />
                                                    <path d="M25.6667 32.666H11V27.3327H25.6667V32.666Z" fill="black"
                                                        fill-opacity="0.2" />
                                                    <path d="M11 24.666V19.3327H32.3333V24.666H24.3333H11Z" fill="black"
                                                        fill-opacity="0.2" />
                                                    <path d="M32.3333 16.666H11V11.3327H32.3333V16.666Z" fill="black"
                                                        fill-opacity="0.2" />
                                                </svg>
                                                <svg v-else-if="IsRepyTo" xmlns="http://www.w3.org/2000/svg" width="57"
                                                    height="52" viewBox="0 0 57 52" fill="none">
                                                    <path 
                                                        d="M37.6668 5.41399H5.66683V38.0007H27.0002V43.334H5.66683C2.7335 43.334 0.333496 40.934 0.333496 38.0007V6.00065C0.333496 3.06732 2.7335 0.667316 5.66683 0.667316H37.6668C40.6002 0.667316 43.0002 3.06732 43.0002 6.00065V24.6673H37.6668V5.41399Z"
                                                        fill="black" fill-opacity="0.2" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                        d="M52.0964 45.9055V51.8674H56.8667V45.9055C56.8667 43.196 55.9085 40.8704 54.0027 38.9592C52.0969 37.048 49.7773 36.0864 47.0742 36.0864H38.0351L44.1733 29.9307L40.7745 26.582L28.9136 38.4769L40.7745 50.3717L44.1733 47.0231L38.0351 40.8674H47.0742C48.477 40.8674 49.6525 41.3536 50.6317 42.3356C51.6109 43.3177 52.0964 44.4972 52.0964 45.9055Z"
                                                        fill="black" fill-opacity="0.2" />
                                                    <path d="M25.6667 32.668H11V27.3346H25.6667V32.668Z" fill="black"
                                                        fill-opacity="0.2" />
                                                    <path d="M11 24.668V19.3346H32.3333V24.668H24.3333H11Z" fill="black"
                                                        fill-opacity="0.2" />
                                                    <path d="M32.3333 16.668H11V11.3346H32.3333V16.668Z" fill="black"
                                                        fill-opacity="0.2" />
                                                </svg>
                                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="64" height="64"
                                                    viewBox="0 0 64 64" fill="none">
                                                    <g clip-path="url(#clip0_1415_21272)">
                                                        <path
                                                            d="M41.3333 37.3333H39.2267L38.48 36.6133C41.0933 33.5733 42.6667 29.6267 42.6667 25.3333C42.6667 15.76 34.9067 8 25.3333 8C15.76 8 8 15.76 8 25.3333C8 34.9067 15.76 42.6667 25.3333 42.6667C29.6267 42.6667 33.5733 41.0933 36.6133 38.48L37.3333 39.2267V41.3333L50.6667 54.64L54.64 50.6667L41.3333 37.3333ZM25.3333 37.3333C18.6933 37.3333 13.3333 31.9733 13.3333 25.3333C13.3333 18.6933 18.6933 13.3333 25.3333 13.3333C31.9733 13.3333 37.3333 18.6933 37.3333 25.3333C37.3333 31.9733 31.9733 37.3333 25.3333 37.3333Z"
                                                            fill="black" fill-opacity="0.2" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_1415_21272">
                                                            <rect width="64" height="64" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </i>
                                        </div>
                                        <span class="no-enquiry-text"
                                            v-html="GetNoneSearchTitle"></span>
                                    </div>
                                    <span class="no-enquiry-desc" v-html="GetNoneSearchText"></span>
                                </div>
                                <div class="no-search-result" v-else-if="searched && isEmpty && !listRefreshing">
                                    <i class="no-search-result-svg">
                                        <svg v-if="IsMathed" xmlns="http://www.w3.org/2000/svg" width="57" height="52"
                                            viewBox="0 0 57 52" fill="none">
                                            <path
                                                d="M37.6668 5.41399H5.66683V38.0007H23.6668V43.334H5.66683C2.7335 43.334 0.333496 40.934 0.333496 38.0007V6.00065C0.333496 3.06732 2.7335 0.667316 5.66683 0.667316H37.6668C40.6002 0.667316 43.0002 3.06732 43.0002 6.00065V24.6673H37.6668V5.41399Z"
                                                fill="black" fill-opacity="0.2" />
                                            <path
                                                d="M34.0337 42.724C29.8997 42.724 21.667 44.791 21.667 48.9073V51.999H46.4003V48.9073C46.4003 44.791 38.1677 42.724 34.0337 42.724ZM25.801 48.4656C27.285 47.441 30.8713 46.2573 34.0337 46.2573C37.196 46.2573 40.7823 47.441 42.2663 48.4656H25.801ZM34.0337 39.6323C37.4433 39.6323 40.217 36.8586 40.217 33.449C40.217 30.0393 37.4433 27.2656 34.0337 27.2656C30.624 27.2656 27.8503 30.0393 27.8503 33.449C27.8503 36.8586 30.624 39.6323 34.0337 39.6323ZM34.0337 30.799C35.5 30.799 36.6837 31.9826 36.6837 33.449C36.6837 34.9153 35.5 36.099 34.0337 36.099C32.5673 36.099 31.3837 34.9153 31.3837 33.449C31.3837 31.9826 32.5673 30.799 34.0337 30.799ZM46.471 42.83C48.5203 44.314 49.9337 46.2926 49.9337 48.9073V51.999H57.0003V48.9073C57.0003 45.3386 50.817 43.307 46.471 42.83ZM44.6337 39.6323C48.0433 39.6323 50.817 36.8586 50.817 33.449C50.817 30.0393 48.0433 27.2656 44.6337 27.2656C43.6797 27.2656 42.7963 27.4953 41.9837 27.884C43.0967 29.4563 43.7503 31.382 43.7503 33.449C43.7503 35.516 43.0967 37.4416 41.9837 39.014C42.7963 39.4026 43.6797 39.6323 44.6337 39.6323Z"
                                                fill="black" fill-opacity="0.2" />
                                            <path d="M25.6667 32.666H11V27.3327H25.6667V32.666Z" fill="black"
                                                fill-opacity="0.2" />
                                            <path d="M11 24.666V19.3327H32.3333V24.666H24.3333H11Z" fill="black"
                                                fill-opacity="0.2" />
                                            <path d="M32.3333 16.666H11V11.3327H32.3333V16.666Z" fill="black"
                                                fill-opacity="0.2" />
                                        </svg>
                                        <svg v-else-if="IsRepyTo" xmlns="http://www.w3.org/2000/svg" width="57"
                                            height="52" viewBox="0 0 57 52" fill="none">
                                            <path
                                                d="M37.6668 5.41399H5.66683V38.0007H27.0002V43.334H5.66683C2.7335 43.334 0.333496 40.934 0.333496 38.0007V6.00065C0.333496 3.06732 2.7335 0.667316 5.66683 0.667316H37.6668C40.6002 0.667316 43.0002 3.06732 43.0002 6.00065V24.6673H37.6668V5.41399Z"
                                                fill="black" fill-opacity="0.2" />
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M52.0964 45.9055V51.8674H56.8667V45.9055C56.8667 43.196 55.9085 40.8704 54.0027 38.9592C52.0969 37.048 49.7773 36.0864 47.0742 36.0864H38.0351L44.1733 29.9307L40.7745 26.582L28.9136 38.4769L40.7745 50.3717L44.1733 47.0231L38.0351 40.8674H47.0742C48.477 40.8674 49.6525 41.3536 50.6317 42.3356C51.6109 43.3177 52.0964 44.4972 52.0964 45.9055Z"
                                                fill="black" fill-opacity="0.2" />
                                            <path d="M25.6667 32.668H11V27.3346H25.6667V32.668Z" fill="black"
                                                fill-opacity="0.2" />
                                            <path d="M11 24.668V19.3346H32.3333V24.668H24.3333H11Z" fill="black"
                                                fill-opacity="0.2" />
                                            <path d="M32.3333 16.668H11V11.3346H32.3333V16.668Z" fill="black"
                                                fill-opacity="0.2" />
                                        </svg>
                                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="64" height="64"
                                            viewBox="0 0 64 64" fill="none">
                                            <g clip-path="url(#clip0_1415_21272)">
                                                <path
                                                    d="M41.3333 37.3333H39.2267L38.48 36.6133C41.0933 33.5733 42.6667 29.6267 42.6667 25.3333C42.6667 15.76 34.9067 8 25.3333 8C15.76 8 8 15.76 8 25.3333C8 34.9067 15.76 42.6667 25.3333 42.6667C29.6267 42.6667 33.5733 41.0933 36.6133 38.48L37.3333 39.2267V41.3333L50.6667 54.64L54.64 50.6667L41.3333 37.3333ZM25.3333 37.3333C18.6933 37.3333 13.3333 31.9733 13.3333 25.3333C13.3333 18.6933 18.6933 13.3333 25.3333 13.3333C31.9733 13.3333 37.3333 18.6933 37.3333 25.3333C37.3333 31.9733 31.9733 37.3333 25.3333 37.3333Z"
                                                    fill="black" fill-opacity="0.2" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1415_21272">
                                                    <rect width="64" height="64" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </i>
                                    <span class="no-search-result-text" v-html="GetNoneSearchText"></span>
                                </div>
                                <div class="search" v-else-if="!listRefreshing || SalesLeadsList.length > 0">
                                    <div class="HoverStyle" v-for="item in SalesLeadsList" :key="item.rid">
                                        <SearchItem
                                            :title="GetLeftMenuTitle(item)"
                                            :content="GetLeftMenuContent(item)"
                                            :date="formatSalesLeadListDate(item.cdate)"
                                            :readDate="item.readDate"
                                            :status="item.status"
                                            :isActive="activeId == item.rid"
                                            :IsInquiry="itemLeadFlags(item).IsInquiry"
                                            :IsMathed="itemLeadFlags(item).IsMathed"
                                            :IsRepyTo="itemLeadFlags(item).IsRepyTo"
                                            :IsNameCard="itemLeadFlags(item).IsNameCard"
                                            :IsLikeFollow="itemLeadFlags(item).IsLikeFollow"
                                            :isAdmin="simulatedSupplier"
                                            @childClicked="searchItemClickHandler(item.rid)"
                                            @changeUnreadStatus="changeUnreadStatus()"
                                        />
                                    </div>
                                </div>
                            </div>
                </div>
                                <div v-if="!loading && listTotalPages > 1 && !isEmpty" class="leftmenu__footer">
                                    <SalesLeadPagination
                                        :current-page="listPageIndex"
                                        :total-pages="listTotalPages"
                                        :is-mobile="isSmallScreen"
                                        @page-change="onListPageChange"
                                    />
                                </div>
                    </div>
                </div>
                <visitorPermission v-if="!simulatedSupplier" class="sales-lead-visitor">
                    <template v-slot:body>
                        <b-overlay :show="childLoading" rounded="sm">
                            <div v-if="IsShowPcCreatedResult" class="sales-lead-empty">
                                <div class="search-result-container">
                                    {{ $t('lbl_EMPBE_SalesLead_ReulstCreate') }}
                                </div>
                            </div>

                            <div
                                v-if="IsShowInquiry || IsShowSourcingRequest || IsShowNameCard || IsShowLikeFollow"
                                class="sales-lead-detail"
                            >
                                <ProductInquiry
                                    v-if="IsShowInquiry"
                                    :InquiryDetail="InquiryDetail"
                                    :loading="childLoading"
                                    :user="user"
                                    :rid="activeId"
                                    :simulatedSupplier="simulatedSupplier"
                                    :mobile="false"
                                />

                                <productSourcingRequest
                                    v-if="IsShowSourcingRequest"
                                    :SalesLeadType="NavTabIndex"
                                    :ObjData="SourcingRequestDetail"
                                    :loading="childLoading"
                                    :mobile="false"
                                    :rid="activeId"
                                    :simulatedSupplier="simulatedSupplier"
                                />

                                <nameCard
                                    v-if="IsShowNameCard"
                                    :NameCardDetail="NameCardDetail"
                                    :loading="childLoading"
                                    :user="user"
                                    :rid="activeId"
                                    :simulatedSupplier="simulatedSupplier"
                                    :mobile="false"
                                />

                                <likeFollowDetail
                                    v-if="IsShowLikeFollow"
                                    :LikeFollowDetail="LikeFollowDetail"
                                    :loading="childLoading"
                                    :user="user"
                                    :rid="activeId"
                                    :simulatedSupplier="simulatedSupplier"
                                    :mobile="false"
                                />
                            </div>
                        </b-overlay>
                    </template>
                </visitorPermission>
                <div v-else class="sales-lead-visitor sales-lead-visitor--admin">
                    <b-overlay :show="childLoading" rounded="sm">
                        <div v-if="IsShowPcCreatedResult" class="sales-lead-empty">
                            <div class="search-result-container">
                                {{ $t('lbl_EMPBE_SalesLead_ReulstCreate') }}
                            </div>
                        </div>
                        <div
                            v-if="IsShowInquiry || IsShowSourcingRequest || IsShowNameCard || IsShowLikeFollow"
                            class="sales-lead-detail"
                        >
                            <ProductInquiry
                                v-if="IsShowInquiry"
                                :InquiryDetail="InquiryDetail"
                                :loading="childLoading"
                                :user="user"
                                :rid="activeId"
                                :simulatedSupplier="simulatedSupplier"
                                :mobile="false"
                            />
                            <productSourcingRequest
                                v-if="IsShowSourcingRequest"
                                :SalesLeadType="NavTabIndex"
                                :ObjData="SourcingRequestDetail"
                                :loading="childLoading"
                                :mobile="false"
                                :rid="activeId"
                                :simulatedSupplier="simulatedSupplier"
                            />
                            <nameCard
                                v-if="IsShowNameCard"
                                :NameCardDetail="NameCardDetail"
                                :loading="childLoading"
                                :user="user"
                                :rid="activeId"
                                :simulatedSupplier="simulatedSupplier"
                                :mobile="false"
                            />
                            <likeFollowDetail
                                v-if="IsShowLikeFollow"
                                :LikeFollowDetail="LikeFollowDetail"
                                :loading="childLoading"
                                :user="user"
                                :rid="activeId"
                                :simulatedSupplier="simulatedSupplier"
                                :mobile="false"
                            />
                        </div>
                    </b-overlay>
                </div>
                <b-sidebar
                    v-if="isSmallScreen && !simulatedSupplier"
                    id="sidebar-productinquiry"
                    width="100%"
                    no-header
                    right
                    z-index="1050"
                    sidebar-class="sales-lead-mobile-sidebar"
                    class="sidebar"
                >
                            <template #default="{ hide }">
                                <ProductInquiry v-if="IsShowPhoneInquiry" :InquiryDetail="InquiryDetail"  :user="user" :rid="activeId" :simulatedSupplier="simulatedSupplier"
                                    :loading="childLoading" :mobile="true" @close="handleMobileDetailClose(hide)" style="container-type: inline-size;min-width: 300px;width: 100%;"/>
                                <productSourcingRequest :SalesLeadType="NavTabIndex" v-if="IsShowPhoneSourcingRequest"
                                    :ObjData="SourcingRequestDetail" :loading="childLoading" :mobile="true"
                                    :rid="activeId"
                                    :simulatedSupplier="simulatedSupplier"
                                    @close="handleMobileDetailClose(hide)" style="container-type: inline-size;min-width: 300px;width: 100%;"/>
                                <nameCard v-if="IsShowPhoneNameCard" :NameCardDetail="NameCardDetail" :loading="childLoading" :user="user" :rid="activeId" :simulatedSupplier="simulatedSupplier"
                                    :mobile="true" @close="handleMobileDetailClose(hide)" style="container-type: inline-size;min-width: 300px;width: 100%;"/>
                                <likeFollowDetail v-if="IsShowPhoneLikeFollow" :LikeFollowDetail="LikeFollowDetail" :loading="childLoading" :user="user" :rid="activeId" :simulatedSupplier="simulatedSupplier"
                                    :mobile="true" @close="handleMobileDetailClose(hide)" style="container-type: inline-size;min-width: 300px;width: 100%;"/>
                            </template>
                            </b-sidebar>
            </div>
        </div>
    </div>

</template>
<script>
import { mapGetters } from "vuex";
import { userService } from "@/_services";
import ProductInquiry from './component/productInquiry.vue';
import unlockQuota_Free from './component/unlockQuota_Free.vue';
import productSourcingRequest from './component/productSourcingRequest.vue';
import GeneralInquiry from './component/generalInquiry.vue';
import SearchItem from './component/searchItem.vue';
import nameCard from './component/nameCard.vue';
import likeFollowDetail from './component/likeFollowDetail.vue';
import SalesLeadToolbar from './component/salesLeadToolbar.vue';
import SalesLeadPagination from './component/salesLeadPagination.vue';
import SalesLeadListSkeleton from './component/salesLeadListSkeleton.vue';
import SalesLeadExportModal from './component/salesLeadExportModal.vue';
import EmpExportInfoModal from '@/components/empDownloadStatusToast/EmpExportInfoModal.vue';
import { InquiryFormService } from '../../_services';
import { AlertDialog } from '@/_helpers/AlertDialog';
import { LogService } from '../../_services/log.Service';
import { runClientExportWithHud, formatClientExportTimestamp, downloadUtf8CsvFile } from '@/_helpers/runClientExportWithHud';
import { oplogExportHud, oplogExportHudHideToast } from '@/_helpers/oplogExportHud.store';
import { empDownloadHudOpen } from '@/_helpers/empDownloadHud.store';
import { formatSalesLeadDate } from '@/_helpers/formatSalesLeadDate';
import SL_MAIN_TAB_ICON_WHITE from '@/_helpers/salesLeadMainTabIconWhite';
import { formatSalesLeadTitleWithCountry } from '@/_helpers/formatSalesLeadTitleWithCountry';
import { totalFromSalesLeadTypeData } from '@/_helpers/salesLeadUnreadTotal';
import * as XLSX from 'xlsx';
import { Swiper as SwiperClass, SwiperSlide as SwiperSlideClass } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

const SL_PAGE_SIZE = 15;
const SL_UNREAD_DATE = '9999-12-31';
const SL_NEWICON_CDN = 'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/';

export default {
    mixins: [AlertDialog],
    props: ['simulatedSupplier'],
    data() {
        return {
            refreshUnlockQuota:true,
            permissionData: null,
            // Vue2 provide/inject is not reactive for primitives; provide a stable object reference instead.
            // Children can read `permissionData.value` (ref-like) or fallback to `user` if needed.
            permissionDataProvider: { value: null },
            keyword: '',
            InquiryDetail: undefined,
            SourcingRequestDetail: undefined,
            LikeFollowDetail: undefined,
            DirectUnread: 0,
            // Free booth quota tip (same as dashboard "FreeTips")
            YearRemainingQuota: 0,
            activeId: -1,
            searched: false,
            lastSearchWord: '',
            childLoading: false,
            loading: false,
            listRefreshing: false,
            widowWidth: window.innerWidth,
            readFilter: 'all',
            listPageIndex: 1,
            listTotalCount: 0,
            exportModalVisible: false,
            exportLimitModalVisible: false,
            exportQueueModalVisible: false,
            exporting: false,
            salesLeadMaxExportRows: null,
            SalesLeadsType: 0,
            NavTabIndex: 0,
            SalesLeadsTypeData:
                [
                    {
                        id: 'all',
                        label: this.$t('lbl_EMPBE_SalesLead_Tab_All'),
                        Nums: 0,
                        NavTab: [],
                        ListData: [],
                        router: 'all',
                    },
                    {
                        id: '0',
                        label: this.$t('lbl_EMPBE_SalesLead_NameCardPage_EnquiriesTab'),
                        Nums: 0,
                        NavTab: [],
                        ListData: [],
                        router: 'default',
                        tabIcon: `${SL_NEWICON_CDN}Enquiry.svg`,
                    },
                    {
                        id: '1',
                        label: this.$t('lbl_EMPBE_SalesLead_NameCardPage_NameCardTab'),
                        Nums: 0,
                        NavTab: [],
                        ListData: [],
                        router: 'nameCard',
                        tabIcon: `${SL_NEWICON_CDN}id_card_small.svg`,
                    },
                    {
                        id: '2',
                        label: this.$t('lbl_EMPBE_SalesLead_LikeFollow'),
                        Nums: 0,
                        NavTab: [],
                        ListData: [],
                        router: 'likeFollow',
                        tabIcon: `${SL_NEWICON_CDN}favorite.svg`,
                      },
                      {
                        id: '3',
                        label: this.$t('lbl_EMPBE_SalesLead_SourcingRequests'),
                        Nums: 0,
                        NavTab:
                            [
                                { id: '0', label: this.$t('lbl_EMPBE_SalesLead_MatchedForYou'), Nums: 0, ListData: [], router: 'SourcingRequestMatched' },
                                { id: '1', label: this.$t('lbl_EMPBE_SalesLead_RepliedByYou'), Nums: 0, ListData: [], router: 'SourcingRequestApplied' },
                            ],
                        ListData: [],
                        router: 'SourcingRequestMatched',
                        tabIcon: `${SL_NEWICON_CDN}Post_match.svg`,
                    },
                ],
            NameCardDetail: undefined,
            currentRouter: '',
            mainTabsSwiperOptions: {
                slidesPerView: 'auto',
                spaceBetween: 8,
                freeMode: true,
                freeModeMomentum: true,
                slidesOffsetAfter: 56,
                slidesOffsetBefore: 4,
                observer: false,
                observeParents: false,
                watchOverflow: true,
            }
            ,
        }
    },
    components: {
        productSourcingRequest,
        ProductInquiry,
        GeneralInquiry,
        SearchItem,
        unlockQuota_Free,
        nameCard,
        likeFollowDetail,
        SalesLeadToolbar,
        SalesLeadPagination,
        SalesLeadListSkeleton,
        SalesLeadExportModal,
        EmpExportInfoModal,
        swiper: SwiperClass,
        swiperSlide: SwiperSlideClass,
    },
    watch: {
        '$route'(to, from) {
            if (!String(to.path || '').includes('/salesLead')) return;
            const prevType = this.SalesLeadsType;
            const prevNav = this.NavTabIndex;
            this.ChangeTabByRoute();
            const typeChanged = this.SalesLeadsType !== prevType;
            const navChanged = this.NavTabIndex !== prevNav;
            if (to.path !== from.path && (typeChanged || navChanged)) {
                this.listPageIndex = 1;
                this.activeId = -1;
                this.InquiryDetail = undefined;
                this.SourcingRequestDetail = undefined;
                this.NameCardDetail = undefined;
                this.LikeFollowDetail = undefined;
                if (typeChanged || navChanged) {
                    this.SalesLeadsTypeFunc();
                }
            }
        },
        SalesLeadsList() {
            // if (this.SalesLeadsList.length > 0)
            //     this.searchItemClickHandler(this.SalesLeadsList[0].rid)
        },
        SalesLeadsType(newVal, oldVal) {
            // 当标签页切换时，刷新配额和 unlockQuota_Free 组件
            if (newVal !== oldVal) {
                this.fetchYearRemainingQuota();
                // 强制刷新 unlockQuota_Free 组件
                this.refreshUnlockQuota = false;
                this.$nextTick(() => {
                    this.refreshUnlockQuota = true;
                });
            }
        },
        NavTabIndex(){},
    },
    provide() {
        return {
            permissionData: this.permissionDataProvider,
            GetDetail :this.GetDetail
        };
    },
    computed: {
   
        ...mapGetters({
            getPermissionJsonByUser: "responsePermission/getPermissionJsonByUser",
        }),
        BoothType(){
            // Prefer permissionData from API; fallback to user fields when permissionData is not available
            const pdType = this.permissionData?.Type;
            if (pdType) return pdType;
            const u = this.user || {};
            if (u.eBoothGrade) return u.eBoothGrade;
            if (Number(u.isMember) > 0) return 'Member';
            if (Number(u.isExhibitor) > 0) return 'Guest';
            return '';
        },  
        IsNonPaidBooth() {
            // Non-paid / free booth: Member or Guest (not A+/A/B/C)
            return ["Guest"].includes(this.BoothType);
        },
        showFreeQuotaTip() {
            // Align with dashboard behavior: show only for Free booth users and when there is remaining free credit.
            return this.IsNonPaidBooth && Number(this.YearRemainingQuota) > 0;
        },
        /** 供应商中心桌面 / 管理员嵌入：右侧内联详情（非手机侧栏） */
        showDesktopDetailPanel() {
            return !this.isSmallScreen || !!this.simulatedSupplier;
        },
        IsShowPcCreatedResult()
        {
            // 仅在 PC 上，且右侧没有任何详情（Inquiry / Sourcing / NameCard）时，显示中间提示文案
            return !this.IsShowInquiry && !this.IsShowSourcingRequest && !this.IsShowNameCard && !this.IsShowLikeFollow && this.showDesktopDetailPanel;
        },
        GetNoneSearchText() {
            if (this.IsAll) {
                return this.$t('lbl_EMPBE_SalesLead_NoEnquiries2');
            }
            if (this.IsMathed) {
                return this.$t('lbl_EMPBE_SalesLead_SourcingMatchedNone');

            } else if (this.IsRepyTo) {
                    var lang= "";
                    if(this.langId==936)
                        lang="simp";
                    else if(this.langId==950)
                        lang ="trad"
                    else 
                        lang ="eng"
                var url = process.env.VUE_APP_EMP_IsUat=="true" ? `https://www.chinaplasonline.com/eMarketplaceUAT/SupplierToken/${lang}?TargetPage=sourcingrequest&SupplierToken=${this.user.token}` : `https://www.chinaplasonline.com/eMarketplace/SupplierToken/${lang}?TargetPage=sourcingrequest&SupplierToken=${this.user.token}`;
                return this.$t('lbl_EMPBE_SalesLead_SourcingRepliesNone', { SourcingRequestWall: url });
            } else if (this.IsLikeFollow) {
                return this.$t('lbl_EMPBE_SalesLead_LikeFollow_Empty_Desc');
            }
            else {
                return this.$t('lbl_EMPBE_SalesLead_NoEnquiries2')
            }
        },
        GetNoneSearchTitle() {
            if (this.IsAll) {
                return this.$t('lbl_EMPBE_SalesLead_NoEnquiries1');
            }
            if (this.IsLikeFollow) {
                return this.$t('lbl_EMPBE_SalesLead_LikeFollow_Empty_Title');
            }
            return this.$t('lbl_EMPBE_SalesLead_NoEnquiries1');
        },
        IsAll() {
            return this.SalesLeadsType === 0;
        },
        IsInquiry() {
            return this.SalesLeadsType === 1;
        },
        IsLikeFollow() {
            return this.SalesLeadsType === 3;
        },
        IsSourcing() {
            return this.SalesLeadsType === 4;
        },
        IsMathed() {
            return this.IsSourcing && this.NavTabIndex === 0;
        },
        IsRepyTo() {
            return this.IsSourcing && this.NavTabIndex === 1;
        },
        IsNameCard() {
            return this.SalesLeadsType === 2;
        },
        selectedListItem() {
            if (this.activeId < 0) return null;
            return (this.SalesLeadsList || []).find((x) => x && x.rid === this.activeId) || null;
        },
        detailIsInquiry() {
            if (this.IsAll && this.selectedListItem) {
                return String(this.selectedListItem.salesLeadType || '').toLowerCase() === 'inquiry';
            }
            return this.IsInquiry;
        },
        detailIsNameCard() {
            if (this.IsAll && this.selectedListItem) {
                return String(this.selectedListItem.salesLeadType || '').toLowerCase() === 'namecard';
            }
            return this.IsNameCard;
        },
        detailIsLikeFollow() {
            if (this.IsAll && this.selectedListItem) {
                return String(this.selectedListItem.salesLeadType || '').toLowerCase() === 'likefollow';
            }
            return this.IsLikeFollow;
        },
        detailIsSourcingMatched() {
            if (this.IsAll && this.selectedListItem) {
                const t = String(this.selectedListItem.salesLeadType || '').toLowerCase();
                const sub = String(this.selectedListItem.salesLeadSourcingSubType || '').toLowerCase();
                return t === 'sourcingrequest' && sub !== 'applied';
            }
            return this.IsMathed;
        },
        detailIsSourcingApplied() {
            if (this.IsAll && this.selectedListItem) {
                const t = String(this.selectedListItem.salesLeadType || '').toLowerCase();
                const sub = String(this.selectedListItem.salesLeadSourcingSubType || '').toLowerCase();
                return t === 'sourcingrequest' && sub === 'applied';
            }
            return this.IsRepyTo;
        },
        listTotalPages() {
            return Math.max(1, Math.ceil((this.listTotalCount || 0) / SL_PAGE_SIZE));
        },
        /** 导出弹窗标题 / 「全部 xxx」里的分类名：与顶部主 Tab、采购子 Tab 对齐 */
        exportTitleTypeName() {
            if (this.IsSourcing) {
                const sub = this.IsMathed
                    ? this.$t('lbl_EMPBE_SalesLead_MatchedForYou')
                    : this.$t('lbl_EMPBE_SalesLead_RepliedByYou');
                return this.$t('lbl_EMPBE_SalesLead_Export_SourcingTitleSegment', { sub });
            }
            return this.exportTypeLabel;
        },
        exportModalTitle() {
            return this.$t('lbl_EMPBE_SalesLead_Export_Title', { salesLeadTypeName: this.exportTitleTypeName });
        },
        exportAllOptionLabel() {
            if (this.IsAll) {
                return this.$t('lbl_EMPBE_SalesLead_Export_AllRecords');
            }
            return this.$t('lbl_EMPBE_SalesLead_Export_AllOfType', { salesLeadTypeName: this.exportTitleTypeName });
        },
        exportTypeLabel() {
            if (this.IsAll) return this.$t('lbl_EMPBE_SalesLead_Tab_All');
            if (this.IsInquiry) return this.$t('lbl_EMPBE_SalesLead_NameCardPage_EnquiriesTab');
            if (this.IsNameCard) return this.$t('lbl_EMPBE_SalesLead_NameCardPage_NameCardTab');
            if (this.IsLikeFollow) return this.$t('lbl_EMPBE_SalesLead_LikeFollow');
            if (this.IsMathed) return this.$t('lbl_EMPBE_SalesLead_MatchedForYou');
            if (this.IsRepyTo) return this.$t('lbl_EMPBE_SalesLead_RepliedByYou');
            return this.$t('lbl_EMPBE_SalesLead_SourcingRequests');
        },
        IsShowInquiry() {
            return this.detailIsInquiry && this.InquiryDetail && this.showDesktopDetailPanel;
        },
        IsShowPhoneInquiry() {
            return this.detailIsInquiry && this.InquiryDetail && !this.showDesktopDetailPanel;
        },
        IsShowSourcingRequest() {
            return (this.detailIsSourcingMatched || this.detailIsSourcingApplied) && this.SourcingRequestDetail && this.showDesktopDetailPanel;
        },
        IsShowPhoneSourcingRequest() {
            return (this.detailIsSourcingMatched || this.detailIsSourcingApplied) && this.SourcingRequestDetail && !this.showDesktopDetailPanel;
        },
        IsShowNameCard() {
            return this.detailIsNameCard && this.NameCardDetail && this.showDesktopDetailPanel;
        },
        IsShowPhoneNameCard() {
            return this.detailIsNameCard && this.NameCardDetail && !this.showDesktopDetailPanel;
        },
        IsShowLikeFollow() {
            return this.detailIsLikeFollow && this.LikeFollowDetail && this.showDesktopDetailPanel;
        },
        IsShowPhoneLikeFollow() {
            return this.detailIsLikeFollow && this.LikeFollowDetail && !this.showDesktopDetailPanel;
        },
        SalesLeadsList() {
            if (this.IsAll || this.IsInquiry || this.IsNameCard || this.IsLikeFollow) {
                return this.SalesLeadsTypeData[this.SalesLeadsType].ListData;
            }
            if (this.IsMathed || this.IsRepyTo) {
                return this.SalesLeadsTypeData[this.SalesLeadsType].NavTab[this.NavTabIndex].ListData;
            }
                return [];
        },
        activeComponent() {
            if (this.InquiryDetail.find(() => true)?.SeqId == 0)
                return 'GeneralInquiry'
            return 'ProductInquiry'
        },
        user() {
            return this.simulatedSupplier ? this.simulatedSupplier : JSON.parse(localStorage.getItem("user"));
        },
        langId() {
            return localStorage.getItem("currentLangId")
        },
        isEmpty() {
            return this.SalesLeadsList.length == 0
        },
        isSmallScreen() {
            return this.widowWidth < 480
        },
        GetSearchbarNavTab() {
            return this.SalesLeadsTypeData[this.SalesLeadsType].NavTab;
        },
        /** 与当前列表一致的搜索关键字（已点搜索则用 lastSearchWord） */
        listFilterKeyword() {
            if (this.searched) return this.lastSearchWord || '';
            return this.keyword || '';
        },
        /** 与操作日志导出超限弹窗一致：仅展示上限 {n} 笔 */
        exportLimitModalSubtitle() {
            const raw = this.salesLeadMaxExportRows;
            const n = raw != null && Number.isFinite(Number(raw)) ? Math.floor(Number(raw)) : null;
            if (n != null && n > 0) {
                const loc = (parseInt(localStorage.getItem('currentLangId'), 10) || 936) === 1252 ? 'en-US' : 'zh-CN';
                return String(this.$t('lbl_EMPBE_SalesLead_Export_LimitSubtitle', { n: n.toLocaleString(loc) }));
            }
            return String(this.$t('lbl_EMPBE_OpLog_ExportLimitModalSubtitleUnknown'));
        },
    },
    methods: {
        applySalesLeadExportFailure(hideToast) {
            if (typeof hideToast === 'function') {
                hideToast();
            } else {
                oplogExportHudHideToast();
            }
            empDownloadHudOpen({
                variant: 'error',
                title: this.$t('lbl_EMPBE_SalesLead_Export_FailTitle'),
                subtitle: this.$t('lbl_EMPBE_SalesLead_Export_FailSubtitle'),
                autoCloseMs: 10_000,
            });
        },
        async ensureSalesLeadExportMaxRowsLoaded() {
            if (Number(this.salesLeadMaxExportRows) > 0) return Number(this.salesLeadMaxExportRows);
            const meta = await InquiryFormService.GetSalesLeadExportMeta();
            const n = meta?.maxExportRows ?? meta?.MaxExportRows;
            if (Number(n) > 0) {
                this.salesLeadMaxExportRows = Number(n);
                return Number(n);
            }
            // fallback（仅兜底；真实值应由 DB 控制）
            this.salesLeadMaxExportRows = 5000;
            return 5000;
        },
        /** 将 IndustryNews 式箭头绑定到 Swiper navigation（prevEl/nextEl 用 ref，因按钮在 vue-awesome-swiper 根外侧） */
        bindSalesLeadMainTabsNavigation() {
            const comp = this.$refs.mainTabsSwiper;
            const prevEl = this.$refs.slMainTabsNavPrev;
            const nextEl = this.$refs.slMainTabsNavNext;
            if (!comp || !prevEl || !nextEl) return;
            const swiper = comp.$swiper || comp.swiper;
            if (!swiper || !swiper.params) return;
            if (!swiper.params.navigation) swiper.params.navigation = {};
            Object.assign(swiper.params.navigation, { prevEl, nextEl });
            if (swiper.navigation && typeof swiper.navigation.destroy === 'function') {
                try {
                    swiper.navigation.destroy();
                } catch (e) { /* ignore */ }
            }
            if (swiper.navigation && typeof swiper.navigation.init === 'function') {
                swiper.navigation.init();
            }
            if (swiper.navigation && typeof swiper.navigation.update === 'function') {
                swiper.navigation.update();
            }
        },
        /** 主 Tab 为横向 Swiper（freeMode）；点击提示向右滑动一屏，便于露出右侧 Tab */
        scrollMainTabsRight() {
            this.$nextTick(() => {
                const comp = this.$refs.mainTabsSwiper;
                if (!comp) return;
                const swiper = comp.$swiper || comp.swiper;
                if (!swiper) return;
                if (typeof swiper.slideNext === 'function') {
                    swiper.slideNext();
                    return;
                }
                const step = Math.min(160, Math.max(80, (swiper.width || 200) * 0.45));
                const cur = typeof swiper.getTranslate === 'function' ? swiper.getTranslate() : 0;
                const minT = typeof swiper.minTranslate === 'function' ? swiper.minTranslate() : -1e6;
                const next = Math.max(minT, cur - step);
                if (typeof swiper.setTranslate === 'function') swiper.setTranslate(next);
            });
        },
        GetDetail()
        {
            this.refreshUnlockQuota=false;
            this.$nextTick(() => {
                this.refreshUnlockQuota=true;
            });
            this.searchItemClickHandler(this.activeId);
        },
        GetSysCompanySponsorType() {
        var that = this;
            if (that.user.empCompanyId > 0) {
                userService
                .GetSysCompanySponsorType({ CompanyId: that.user.empCompanyId })
                .then((res) => {
                    if (res.isSuccessful) {
                        var data = res.data;
                        that.permissionData = this.getPermissionJsonByUser({ user: data });
                        that.permissionDataProvider.value = that.permissionData;
                    }
                });
            }
        },
        ChangeTabByRoute() {
            const routePath = this.$route.path;
            if (routePath.includes('SourcingRequestMatched')) {
                this.SalesLeadsType = 4;
                this.NavTabIndex = 0;
            } else if (routePath.includes('SourcingRequestApplied')) {
                this.SalesLeadsType = 4;
                this.NavTabIndex = 1;
            } else if (routePath.includes('nameCard')) {
                this.SalesLeadsType = 2;
            } else if (routePath.includes('likeFollow')) {
                this.SalesLeadsType = 3;
            } else if (routePath.includes('/salesLead/default')) {
                this.SalesLeadsType = 1;
            } else if (routePath.includes('/salesLead/all') || routePath.endsWith('/salesLead')) {
                this.SalesLeadsType = 0;
            } else {
                this.SalesLeadsType = 0;
            }
        },
        init() {
            this.loading = true;
            this.keyword = undefined;
            this.searched = false;
            this.listPageIndex = 1;
            this.fetchYearRemainingQuota();
            this.refreshAllTabCounts();
            this.loadCurrentListPage();
        },
        listQueryOptions() {
            return {
                pageIndex: this.listPageIndex,
                pageSize: SL_PAGE_SIZE,
                unreadOnly: this.readFilter === 'unread',
            };
        },
        parsePagedListResponse(raw) {
            if (!raw) {
                return { list: [], totalCount: 0, pageIndex: 1, unreadCount: undefined };
            }
            const ok = raw.isSuccessful ?? raw.IsSuccessful;
            if (ok === false) {
                return { list: [], totalCount: 0, pageIndex: 1, unreadCount: undefined };
            }
            const body = raw.data ?? raw.Data ?? raw;
            const items = body?.items ?? body?.Items;
            if (body && Array.isArray(items)) {
                const parsed = {
                    list: items,
                    totalCount: Number(body.totalCount ?? body.TotalCount) || 0,
                    pageIndex: Number(body.pageIndex ?? body.PageIndex) || 1,
                    unreadCount: body.unreadCount ?? body.UnreadCount,
                };
                return parsed;
            }
            const list = Array.isArray(body) ? body : (Array.isArray(raw) ? raw : (body ? [body] : []));
            const parsed = {
                list,
                totalCount: list.length,
                pageIndex: 1,
                unreadCount: undefined,
            };
            return parsed;
        },
        countUnread(rows) {
            return (rows || []).filter(
                (a) => a && (a.readDate === SL_UNREAD_DATE || a.ReadDate === SL_UNREAD_DATE)
            ).length;
        },
        syncAllTabBadge() {
            const d = this.SalesLeadsTypeData;
            const total = totalFromSalesLeadTypeData(d);
            if (d[0]) d[0].Nums = total;
            if (!this.simulatedSupplier) {
                this.$store.dispatch('unread/setUnread', { unread: total, type: 'salesLead' });
            }
        },
        itemLeadFlags(item) {
            if (!item) {
                return { IsInquiry: false, IsNameCard: false, IsLikeFollow: false, IsMathed: false, IsRepyTo: false };
            }
            if (!this.IsAll) {
                return {
                    IsInquiry: this.IsInquiry,
                    IsNameCard: this.IsNameCard,
                    IsLikeFollow: this.IsLikeFollow,
                    IsMathed: this.IsMathed,
                    IsRepyTo: this.IsRepyTo,
                };
            }
            const type = String(item.salesLeadType || '').toLowerCase();
            const sub = String(item.salesLeadSourcingSubType || '').toLowerCase();
            return {
                IsInquiry: type === 'inquiry',
                IsNameCard: type === 'namecard',
                IsLikeFollow: type === 'likefollow',
                IsMathed: type === 'sourcingrequest' && sub !== 'applied',
                IsRepyTo: type === 'sourcingrequest' && sub === 'applied',
            };
        },
        onReadFilterChange(value) {
            this.readFilter = value;
            this.listPageIndex = 1;
            this.loadCurrentListPage();
        },
        onListPageChange(page) {
            if (page === this.listPageIndex) return;
            this.listPageIndex = page;
            this.loadCurrentListPage();
        },
        refreshAllTabCounts() {
            const cid = this.user?.empCompanyId;
            if (!cid) return;
            const kw = this.listFilterKeyword;
            if (!kw) {
                InquiryFormService.GetUnreadNum(cid).then((res) => {
                    const first = res && res.length ? res[0] : {};
                    const inquiryUnread = Number(first.direct ?? 0) || 0;
                    const nameCardUnread = Number(first.nameCardNums ?? first.nameCardNum ?? 0) || 0;
                    const likeFollowUnread = Number(first.likeFollowNums ?? first.likeFollowNum ?? 0) || 0;
                    const matched = Number(first.sourcingRequestsNums ?? 0) || 0;
                    const applied = Number(first.sourcingContactBuyerFormNums ?? 0) || 0;
                    this.SalesLeadsTypeData[1].Nums = inquiryUnread;
                    this.SalesLeadsTypeData[2].Nums = nameCardUnread;
                    this.SalesLeadsTypeData[3].Nums = likeFollowUnread;
                    if (this.SalesLeadsTypeData[4]?.NavTab?.[0]) {
                        this.SalesLeadsTypeData[4].NavTab[0].Nums = matched;
                    }
                    if (this.SalesLeadsTypeData[4]?.NavTab?.[1]) {
                        this.SalesLeadsTypeData[4].NavTab[1].Nums = applied;
                    }
                    this.SalesLeadsTypeData[4].Nums = matched + applied;
                    this.syncAllTabBadge();
                }).catch(() => {});
                return;
            }
            Promise.all([
                InquiryFormService.GetInquiryList(cid, kw, { pageIndex: 1, pageSize: 1 }).then((res) => {
                    const parsed = this.parsePagedListResponse(res);
                    const unread = parsed.unreadCount;
                    this.SalesLeadsTypeData[1].Nums =
                        unread != null ? Number(unread) || 0 : this.countUnread(parsed.list);
                }),
                InquiryFormService.GetNameCardList(cid, kw, { pageIndex: 1, pageSize: 1 }).then((res) => {
                    const parsed = this.parsePagedListResponse(res);
                    const unread = parsed.unreadCount;
                    this.SalesLeadsTypeData[2].Nums =
                        unread != null ? Number(unread) || 0 : this.countUnread(parsed.list);
                }),
                InquiryFormService.GetLikeFollowList(cid, kw, { pageIndex: 1, pageSize: 1 }).then((res) => {
                    const parsed = this.parsePagedListResponse(res);
                    const unread = parsed.unreadCount;
                    this.SalesLeadsTypeData[3].Nums =
                        unread != null ? Number(unread) || 0 : this.countUnread(parsed.list);
                }),
                this.GetSourcingRequestCounts(kw),
            ]).then(() => {
                this.syncAllTabBadge();
            });
        },
        async GetSourcingRequestCounts(keyword) {
            const cid = this.user.empCompanyId;
            const countOpts = { companyId: cid, keyword, pageIndex: 1, pageSize: 1 };
            const [matched, applied] = await Promise.all([
                InquiryFormService.GetSourcingMatching(countOpts),
                InquiryFormService.GetSourcingContactBuyer(countOpts),
            ]);
            const m = this.parsePagedListResponse(matched);
            const a = this.parsePagedListResponse(applied);
            this.SalesLeadsTypeData[4].NavTab[0].Nums =
                m.unreadCount != null ? Number(m.unreadCount) || 0 : this.countUnread(m.list);
            this.SalesLeadsTypeData[4].NavTab[1].Nums =
                a.unreadCount != null ? Number(a.unreadCount) || 0 : this.countUnread(a.list);
            this.SalesLeadsTypeData[4].Nums =
                this.SalesLeadsTypeData[4].NavTab[0].Nums + this.SalesLeadsTypeData[4].NavTab[1].Nums;
        },
        fetchYearRemainingQuota() {
            // Used for the "free credits left to unlock" tag on tabs (Figma matches dashboard)
            if (this.simulatedSupplier) {
                this.YearRemainingQuota = 0;
                return;
            }
            const companyId = this.user?.empCompanyId;
            if (!companyId) {
                this.YearRemainingQuota = 0;
                return;
            }
            // Prefer the same source as unlock-quota UI: GetUnlockQuotaFree returns yearUnlockQuota.yearRemainingQuota
            // IMPORTANT: Free unlock quota is per UnlockType (Enquiry vs NameCard). Passing a constant here will cause mixing.
            const unlockType = this.IsNameCard ? 'NameCard' : (this.IsLikeFollow ? 'Bookmark' : 'Enquiry');
            InquiryFormService.GetUnlockQuotaFree({ companyId: companyId, type: unlockType })
                .then((res) => {
                    const year = res?.yearUnlockQuota || res?.YearUnlockQuota;
                    const remaining = year?.yearRemainingQuota || year?.YearRemainingQuota;
                    this.YearRemainingQuota = Number(remaining || 0);
                })
                .catch(() => {
                    // Fallback (older API contracts): try unread num response
                    InquiryFormService.GetUnreadNum(companyId)
                        .then((res) => {
                            const remaining = res && res.length ? res[0]?.yearRemainingQuota || res[0]?.YearRemainingQuota : 0;
                            this.YearRemainingQuota = Number(remaining || 0);
                        })
                        .catch(() => {
                            this.YearRemainingQuota = 0;
                        });
                });
        },
        resetRemarkDirtyState() {
            this.$store.state.dirty = false;
        },
        async confirmLeaveIfRemarkDirty() {
            if (!this.$store.state.dirty) {
                return true;
            }
            const result = await this.showLeavePage();
            if (result && (result.isConfirmed || result.value)) {
                this.resetRemarkDirtyState();
                return true;
            }
            return false;
        },
        async handleMobileDetailClose(hide) {
            const canLeave = await this.confirmLeaveIfRemarkDirty();
            if (canLeave && typeof hide === 'function') {
                hide();
            }
        },
        formatSalesLeadListDate(value) {
            return formatSalesLeadDate(value);
        },
        mainTabIconSrc(item, index) {
            if (!item.tabIcon) return '';
            if (this.SalesLeadsType !== index) return item.tabIcon;
            return SL_MAIN_TAB_ICON_WHITE[item.id] || item.tabIcon;
        },
        scrollMainTabTo(index) {
            const comp = this.$refs.mainTabsSwiper;
            const swiper = comp && (comp.$swiper || comp.swiper);
            const slide = swiper?.slides?.[index];
            if (!slide) return Promise.resolve();

            const slideEl = slide.$el || slide;
            const viewW = swiper.width || swiper.el?.clientWidth || 0;
            if (viewW < 1) return Promise.resolve();

            const offsetBefore = Number(swiper.params?.slidesOffsetBefore) || 0;
            const offsetAfter = Number(swiper.params?.slidesOffsetAfter) || 0;
            const wrapper = swiper.wrapperEl || (swiper.$wrapperEl && swiper.$wrapperEl[0]);
            const scrollW = wrapper?.scrollWidth || 0;

            let minT = 0;
            if (scrollW > viewW + 1) {
                minT = -(scrollW - viewW + offsetAfter);
            }
            const maxT = offsetBefore;

            const slideOffset = typeof slide.swiperSlideOffset === 'number'
                ? slide.swiperSlideOffset
                : slideEl.offsetLeft;
            const slideWidth = slideEl.offsetWidth || slideEl.clientWidth || 0;
            if (slideWidth < 1) return Promise.resolve();

            let target = -(slideOffset + slideWidth * 0.5 - viewW * 0.5);
            target = Math.max(minT, Math.min(maxT, Math.round(target)));

            const cur = typeof swiper.getTranslate === 'function' ? swiper.getTranslate() : maxT;
            if (!Number.isFinite(cur) || Math.abs(target - cur) < 2) {
                return Promise.resolve();
            }

            if (this._mainTabScrollTimer) {
                clearTimeout(this._mainTabScrollTimer);
                this._mainTabScrollTimer = null;
            }

            const speed = 300;
            if (typeof swiper.setTransition === 'function') swiper.setTransition(speed);
            if (typeof swiper.setTranslate === 'function') swiper.setTranslate(target);

            return new Promise((resolve) => {
                this._mainTabScrollTimer = setTimeout(() => {
                    this._mainTabScrollTimer = null;
                    if (typeof swiper.setTransition === 'function') swiper.setTransition(0);
                    resolve();
                }, speed + 20);
            });
        },
        pushMainTabRoute(index) {
            if (this.simulatedSupplier) return;
            const item = this.SalesLeadsTypeData[index];
            if (!item || !item.router) return;
            const path = `/salesLead/${item.router}`;
            if (this.$route.path !== path) {
                this.$router.push({ path }).catch(() => {});
            }
        },
        beginListLoad() {
            if (!this.listRefreshing) {
                this.loading = true;
            }
        },
        endListLoad() {
            this.loading = false;
            this.listRefreshing = false;
        },
        async ChangeMainTab(index) {
            if (index === this.SalesLeadsType) {
                await this.scrollMainTabTo(index);
                return;
            }
            const canLeave = await this.confirmLeaveIfRemarkDirty();
            if (!canLeave) {
                return;
            }

            this.SalesLeadsType = index;
            await this.$nextTick();
            const scrollPromise = this.scrollMainTabTo(index);

            this.listRefreshing = true;
            this.activeId = -1;
            this.InquiryDetail = undefined;
            this.SourcingRequestDetail = undefined;
            this.NameCardDetail = undefined;
            this.LikeFollowDetail = undefined;
            this.childLoading = false;
            this.pushMainTabRoute(index);
            this.fetchYearRemainingQuota();
            this.SalesLeadsTypeFunc();

            await scrollPromise;
        },
        async ChangeSearchTab(index) {
            if (index === this.NavTabIndex) {
                return;
            }
            const canLeave = await this.confirmLeaveIfRemarkDirty();
            if (!canLeave) {
                return;
            }
            this.NavTabIndex = index;

            // 切换内部导航时，同样清空当前选中项与详情，让右侧先保持空白
            this.activeId = -1;
            this.InquiryDetail = undefined;
            this.SourcingRequestDetail = undefined;
            this.NameCardDetail = undefined;
            this.childLoading = false;

            if (this.IsSourcing) {
                this.listPageIndex = 1;
                this.GetSourcingRequestAll();
            }
        },
        search() {
            this.searched = true;
            this.lastSearchWord = this.keyword;
            this.listPageIndex = 1;
            this.refreshAllTabCounts();
            this.loadCurrentListPage();
        },
        SalesLeadsTypeFunc() {
            this.listPageIndex = 1;
            this.loadCurrentListPage();
        },
        loadCurrentListPage() {
            if (this.IsAll) return this.GetAllSalesLeadListFunc();
            if (this.IsInquiry) return this.GetInquiryListFunc();
            if (this.IsMathed || this.IsRepyTo) return this.GetSourcingRequestAll();
            if (this.IsNameCard) return this.GetNameCardListFunc();
            if (this.IsLikeFollow) return this.GetLikeFollowAll();
            return Promise.resolve();
        },
        GetAllSalesLeadListFunc() {
            const that = this;
            that.beginListLoad();
            const opts = that.listQueryOptions();
            return InquiryFormService.GetAllSalesLeadList(that.user.empCompanyId, that.listFilterKeyword, opts)
                .then((res) => {
                    const parsed = that.parsePagedListResponse(res);
                    that.SalesLeadsTypeData[0].ListData = parsed.list;
                    that.listTotalCount = parsed.totalCount;
                    that.listPageIndex = parsed.pageIndex;
                    that.endListLoad();
                    if (that.IsAll) {
                        that.activeId = -1;
                        that.InquiryDetail = undefined;
                        that.SourcingRequestDetail = undefined;
                        that.NameCardDetail = undefined;
                        that.LikeFollowDetail = undefined;
                    }
                })
                .catch((err) => {
                    that.SalesLeadsTypeData[0].ListData = [];
                    that.listTotalCount = 0;
                    that.endListLoad();
                });
        },
      GetLikeFollowAll() {
        const that = this;
        that.beginListLoad();
        const opts = that.listQueryOptions();
        return InquiryFormService.GetLikeFollowList(that.user.empCompanyId, that.listFilterKeyword, opts)
          .then((res) => {
            const parsed = that.parsePagedListResponse(res);
            that.SalesLeadsTypeData[3].ListData = parsed.list;
            that.listTotalCount = parsed.totalCount;
            that.listPageIndex = parsed.pageIndex;
            that.endListLoad();
            if (that.IsLikeFollow) {
              that.activeId = -1;
              that.LikeFollowDetail = null;
            }
          })
          .catch((err) => {
            that.SalesLeadsTypeData[3].ListData = [];
            that.listTotalCount = 0;
            that.endListLoad();
            if (that.IsLikeFollow) {
              that.activeId = -1;
              that.LikeFollowDetail = null;
            }
          });
        },
        GetLeftMenuTitle(item) {
            const flags = this.itemLeadFlags(item);
            if (flags.IsInquiry) {
                var countryName = this.langId == 1252 ? item.countryName_eng : (this.langId == 950 ? item.countryName_trad : item.countryName_simp);
                return formatSalesLeadTitleWithCountry(this, 'lbl_EMPBE_SalesLead_fromCountry', { buyerCountry: countryName, compName: item.compName });
            }
            else if (flags.IsMathed) {
                var countryName = this.langId == 1252 ? item.countryName_eng : (this.langId == 950 ? item.countryName_trad : item.countryName_simp);
                return formatSalesLeadTitleWithCountry(this, 'lbl_EMPBE_SalesLead_fromRequestMatching', { buyerCountry: countryName, compName: item.compName });
            }
            else if (flags.IsRepyTo) {
                return this.$t('lbl_EMPBE_SalesLead_YourReplyTo', { compName: item.compName })
            }
            else if (flags.IsNameCard) {
                if (this.nameCardListItemIsReplied(item)) {
                    return this.$t('lbl_EMPBE_SalesLead_NameCardList_StatusReplied');
                }
                var countryName = this.langId == 1252 ? item.countryName_eng : (this.langId == 950 ? item.countryName_trad : item.countryName_simp);
                return formatSalesLeadTitleWithCountry(this, 'lbl_EMPBE_SalesLead_NameCardPage_FromBuyerAndRegion', { buyerName: item.buyerName || '', buyerCountryAndRegion: countryName });
            } else if (flags.IsLikeFollow) {
                var countryNameLf = this.langId == 1252 ? item.countryName_eng : (this.langId == 950 ? item.countryName_trad : item.countryName_simp);
                const buyerNameLf = item.buyerNameMasked || item.buyerName || '***';
                return formatSalesLeadTitleWithCountry(this, 'lbl_EMPBE_SalesLead_LikeFollow_BuyerTitle', { buyerName: buyerNameLf, buyerCountry: countryNameLf });
            }
            return '';
        },
      nameCardListItemIsReplied(item) {
            if (!item) return false;
            const ir = item.isReplied ?? item.IsReplied;
            if (ir === 0 || ir === false || String(ir) === '0') return false;
            if (ir === 1 || ir === true || String(ir) === '1') return true;
            const hq = item.hasReply ?? item.HasReply;
            if (hq === 1 || hq === true || String(hq) === '1') return true;
            const rd = item.replyDate ?? item.ReplyDate;
            if (rd != null && String(rd).trim() !== '' && String(rd) !== '9999-12-31' && !String(rd).startsWith('1900-01-01')) {
                return true;
            }
            const rb = item.repliedBy ?? item.RepliedBy ?? item.repliedByName ?? item.RepliedByName;
            return !!(rb && String(rb).trim() !== '');
        },
      /** 公司「关注」类事件：即使带 EmpProductId/产品名，列表摘要也应走「关注供应商」文案，而非点赞产品 */
      likeFollowItemIsCompanyFollowEvent(item) {
        if (!item) return false;
        const ec = String(item.eventCode ?? item.EventCode ?? '').trim().toUpperCase();
        if (!ec) return false;
        if (ec.includes('UNFOLLOW')) return false;
        if (ec.includes('FOLLOW')) return true;
        if (ec.includes('COMPANY') && !ec.includes('PRODUCT')) return true;
        return false;
      },
      /** 当前登录供应商公司名（与 sidebar/dashboard 一致：优先 companyName* 三语） */
      likeFollowSupplierCompanyDisplayName() {
        const authUser = this.$store?.state?.authentication?.user || {};
        const u = this.user || {};
        const pick = (o) => {
          if (!o || typeof o !== 'object') return '';
          const direct = String(o.companyName || o.compName || o.compname || '').trim();
          if (direct) return direct;
          const en = o.companyNameEn || '';
          const sc = o.companyNameSc || '';
          const tc = o.companyNameTc || '';
          const lid = String(this.langId);
          let byLang = '';
          if (lid === '1252') byLang = en || sc || tc;
          else if (lid === '950') byLang = tc || sc || en;
          else byLang = sc || tc || en;
          return String(byLang || o.displayName || '').trim();
        };
        return pick(u) || pick(authUser);
      },
      GetLeftMenuContent(item) {
        const flags = this.itemLeadFlags(item);
        if (!flags.IsLikeFollow) {
          return item.content;
        }

        const productName = this.langId == 1252
          ? (item.productName_eng || item.productName_simp || item.productName_trad || '')
          : (this.langId == 950
            ? (item.productName_trad || item.productName_simp || item.productName_eng || '')
            : (item.productName_simp || item.productName_trad || item.productName_eng || ''));

        const supplierCompanyName = this.likeFollowSupplierCompanyDisplayName();
        const productId = Number(item.empProductId ?? item.EmpProductId ?? 0);
        if (productId > 0) {
          return this.$t('lbl_EMPBE_SalesLead_LikeFollow_LikedProductWithName', { productName });
        }

        if (supplierCompanyName) {
          return this.$t('lbl_EMPBE_SalesLead_LikeFollow_FollowedCompanyWithName', { companyName: supplierCompanyName });
        }
        return this.$t('lbl_EMPBE_SalesLead_LikeFollow_FollowedYourCompany');
        },
        GetInquiryListFunc() {
            var that = this;
            that.beginListLoad();
            const opts = that.listQueryOptions();
            return InquiryFormService.GetInquiryList(that.user.empCompanyId, that.listFilterKeyword, opts)
                .then((res) => {
                    const parsed = that.parsePagedListResponse(res);
                    that.SalesLeadsTypeData[1].ListData = parsed.list;
                    that.listTotalCount = parsed.totalCount;
                    that.listPageIndex = parsed.pageIndex;
                    that.endListLoad();
                })
                .catch((err) => {
                    that.SalesLeadsTypeData[1].ListData = [];
                    that.listTotalCount = 0;
                    that.endListLoad();
                });
        },
        async GetSourcingRequestAll() {
            this.beginListLoad();
            try {
                if (this.IsMathed) {
            await this.GetSourcingMatchingListFunc();
                } else if (this.IsRepyTo) {
            await this.GetSourcingContactBuyerListFunc();
                } else {
                    await Promise.all([
                        this.GetSourcingMatchingListFunc(),
                        this.GetSourcingContactBuyerListFunc(),
                    ]);
                }
                this.SalesLeadsTypeData[4].Nums =
                    this.SalesLeadsTypeData[4].NavTab[0].Nums + this.SalesLeadsTypeData[4].NavTab[1].Nums;
                this.syncAllTabBadge();
            } finally {
                this.endListLoad();
            }
        },
        async GetSourcingMatchingListFunc() {
            var that = this;
            const opts = { ...that.listQueryOptions(), companyId: that.user.empCompanyId, keyword: that.listFilterKeyword };
            await InquiryFormService.GetSourcingMatching(opts)
                .then((res) => {
                    const parsed = that.parsePagedListResponse(res);
                    if (that.IsMathed) {
                        that.listTotalCount = parsed.totalCount;
                        that.listPageIndex = parsed.pageIndex;
                    }
                    that.SalesLeadsTypeData[4].NavTab[0].ListData = parsed.list;
                    if (that.IsMathed) {
                        const unread = parsed.unreadCount;
                        that.SalesLeadsTypeData[4].NavTab[0].Nums =
                            unread != null ? Number(unread) || 0 : that.countUnread(parsed.list);
                    }
                });
        },
        async GetSourcingContactBuyerListFunc() {
            var that = this;
            const opts = { ...that.listQueryOptions(), companyId: that.user.empCompanyId, keyword: that.listFilterKeyword };
            await InquiryFormService.GetSourcingContactBuyer(opts)
                .then((res) => {
                    const parsed = that.parsePagedListResponse(res);
                    if (that.IsRepyTo) {
                        that.listTotalCount = parsed.totalCount;
                        that.listPageIndex = parsed.pageIndex;
                    }
                    that.SalesLeadsTypeData[4].NavTab[1].ListData = parsed.list;
                    if (that.IsRepyTo) {
                        const unread = parsed.unreadCount;
                        that.SalesLeadsTypeData[4].NavTab[1].Nums =
                            unread != null ? Number(unread) || 0 : that.countUnread(parsed.list);
                    }
                });
        },
        clear() {
            this.keyword = '';
            this.searched = false;
            this.lastSearchWord = '';
            this.listPageIndex = 1;
            this.refreshAllTabCounts();
            this.loadCurrentListPage();
        },
        recordSalesLeadView(formType, rid, detail) {
            if (!formType || rid == null || rid === '' || rid === -1) return;
            const numericRid = Number(rid);
            const ridKey = String(Number.isFinite(numericRid) ? numericRid : rid);
            const pickBizFields = (obj) => {
                if (!obj || typeof obj !== 'object') return {};
                const out = {};
                const uc = obj.uniqueCode ?? obj.UniqueCode;
                if (uc != null && String(uc).trim() !== '') out.uniqueCode = String(uc).trim();
                const fc = obj.formCode ?? obj.FormCode;
                if (fc != null && String(fc).trim() !== '') out.formCode = String(fc).trim();
                const ec = obj.eventCode ?? obj.EventCode;
                if (ec != null && String(ec).trim() !== '') out.eventCode = String(ec).trim();
                const refAlt = obj.refNo ?? obj.RefNo;
                if (refAlt != null) {
                    const s = String(refAlt).trim();
                    if (s && s !== ridKey) out.refNo = s;
                }
                return out;
            };
            let bizFields = pickBizFields(detail);
            if (!Object.keys(bizFields).length) {
                bizFields = pickBizFields((this.SalesLeadsList || []).find((x) => x && String(x.rid) === ridKey));
            }
            const formRid = Number.isFinite(numericRid) ? numericRid : rid;
            const payload = {
                FormId: Number.isFinite(numericRid) ? numericRid : 0,
                Action: 'Open',
                FormType: formType,
                FormJSON: JSON.stringify({ rid: formRid, ...bizFields }),
                ErrorLog: null,
            };
            if (this.simulatedSupplier) {
                const companyId = Number(this.user?.empCompanyId) || 0;
                if (companyId > 0) payload.EmpCompanyId = companyId;
            }
            LogService.LogFormData(payload).catch(() => {});
        },
        resolveSalesLeadExportLogFormType(leadType) {
            const map = {
                all: 'SalesleadBack_All',
                inquiry: 'SalesleadBack_Inquiry',
                nameCard: 'SalesleadBack_NameCard',
                likeFollow: 'SalesleadBack_LikeFollow',
                matched: 'SalesleadBack_SourcingRequest_Matched',
                applied: 'SalesleadBack_SourcingRequest_Applied',
            };
            return map[String(leadType || '').toLowerCase()] || map.all;
        },
        resolveSalesLeadExportLeadTypeLabel(leadType, sheetNames) {
            const key = String(leadType || '').toLowerCase();
            if (key === 'all') {
                return this.$t('lbl_EMPBE_SalesLead_Tab_All');
            }
            const labelMap = {
                inquiry: sheetNames?.inquiry,
                nameCard: sheetNames?.nameCard,
                likeFollow: sheetNames?.likeFollow,
                matched: sheetNames?.matched,
                applied: sheetNames?.applied,
            };
            return labelMap[key] || key;
        },
        buildSalesLeadExportAuditFormData(meta) {
            const u = this.$store?.state?.authentication?.user || {};
            const nav = typeof window !== 'undefined' && window.navigator ? window.navigator : {};
            const companyId = Number(this.user?.empCompanyId) || 0;
            const langId = parseInt(localStorage.getItem('currentLangId'), 10) || 936;
            return {
                event: 'SalesLeadExportExcel',
                leadType: meta.leadType,
                leadTypeLabel: meta.leadTypeLabel,
                rangeMode: meta.rangeMode,
                fromDate: meta.fromDate || null,
                toDate: meta.toDate || null,
                format: meta.format,
                unreadOnly: !!meta.unreadOnly,
                keyword: meta.keyword || '',
                totalCount: meta.totalCount,
                sheetBreakdown: meta.sheetBreakdown || null,
                fileName: meta.fileName || null,
                maxExportRowsAtExport: meta.maxExportRows != null ? meta.maxExportRows : null,
                targetCompanyId: companyId,
                exporter: {
                    accountUserId: u.accountUserId ?? u.AccountUserId ?? null,
                    simulatedSupplierView: !!this.simulatedSupplier,
                },
                routePath: this.$route?.path || null,
                langId,
                userAgent: nav.userAgent || null,
                exportedAtUtc: new Date().toISOString(),
            };
        },
        logSalesLeadExportToFormData(meta) {
            if (this.simulatedSupplier) return;
            try {
                const formData = this.buildSalesLeadExportAuditFormData(meta);
                let json = JSON.stringify(formData);
                const maxJson = 32000;
                if (json.length > maxJson) {
                    json = `${json.slice(0, maxJson - 40)}…"truncated":true}`;
                }
                const formIdNum = Number(formData.targetCompanyId);
                LogService.LogFormData({
                    FormId: Number.isFinite(formIdNum) && formIdNum > 0 ? formIdNum : 0,
                    Action: 'ExportExcel',
                    FormType: this.resolveSalesLeadExportLogFormType(meta.leadType),
                    FormJSON: json,
                    ErrorLog: null,
                }).catch(() => {});
            } catch (_) {}
        },
        GetInquiryDetail(param) {
            this.childLoading = true;
            InquiryFormService.GetInquiryDetail(param)
                .then((res) => {
                    const row = res && res[0] ? res[0] : null;
                    this.InquiryDetail = row;
                    this.recordSalesLeadView('SalesleadBack_Inquiry', param, row);
                    this.childLoading = false;
                    this.loading = false;
                })
                .catch(() => {
                    this.childLoading = false;
                    this.loading = false;
                });
        },
        GetSourcingMatchedDetail(param) {
            this.childLoading = true;
            InquiryFormService.GetSourcingMatchingDetail({ langId: this.langId, rid: param })
                .then((res) => {
                    const row = res && res[0] ? res[0] : null;
                    this.SourcingRequestDetail = row;
                    this.recordSalesLeadView('SalesleadBack_SourcingRequest_Matched', param, row);
                    this.childLoading = false;
                    this.loading = false;
                })
                .catch(() => {
                    this.childLoading = false;
                    this.loading = false;
                });
        },
        GetSourcingContactBuyerDetail(param) {
            this.childLoading = true;
            InquiryFormService.GetSourcingContactBuyerDetail({ langId: this.langId, rid: param })
                .then((res) => {
                    const row = res && res[0] ? res[0] : null;
                    this.SourcingRequestDetail = row;
                    this.recordSalesLeadView('SalesleadBack_SourcingRequest_Applied', param, row);
                    this.childLoading = false;
                    this.loading = false;
                })
                .catch(() => {
                    this.childLoading = false;
                    this.loading = false;
                });
        },
        // GetUnreadNum(){
        //     InquiryFormService.GetUnreadNum(this.user.empCompanyId)
        //     .then((res) => 
        //     {
        //         this.SalesLeadsTypeData[0].Nums = res[0].direct;
        //     });
        // },
        async searchItemClickHandler(param) {
            if (param !== this.activeId) {
                const canLeave = await this.confirmLeaveIfRemarkDirty();
                if (!canLeave) {
                    return;
                }
            }
            // 更新 activeId 并刷新详情
            this.activeId = param;

            const item = (this.SalesLeadsList || []).find((x) => x && x.rid === param);
            const flags = this.itemLeadFlags(item);
            if (flags.IsInquiry || (this.IsInquiry && !this.IsAll))
                this.GetInquiryDetail(param);
            else if (flags.IsMathed || (this.IsMathed && !this.IsAll))
                this.GetSourcingMatchedDetail(param);
            else if (flags.IsRepyTo || (this.IsRepyTo && !this.IsAll))
                this.GetSourcingContactBuyerDetail(param);
            else if (flags.IsNameCard || (this.IsNameCard && !this.IsAll))
                this.GetNameCardDetail(param);
            else if (flags.IsLikeFollow || (this.IsLikeFollow && !this.IsAll))
              this.GetLikeFollowDetail(param);
            if (!this.simulatedSupplier && this.isSmallScreen) {
                this.$nextTick(() => {
                    this.$root.$emit('bv::toggle::collapse', 'sidebar-productinquiry');
                });
            }
        },
        changeUnreadStatus() {
            if (this.simulatedSupplier) return;
            if (this.IsAll) {
                this.refreshAllTabCounts();
                return;
            }
            if (this.IsMathed || this.IsRepyTo) {
                this.SalesLeadsTypeData[this.SalesLeadsType].NavTab[this.NavTabIndex].Nums -= 1;
            }
            this.SalesLeadsTypeData[this.SalesLeadsType].Nums -= 1;
            this.syncAllTabBadge();
        },
        GetLikeFollowDetail(param) {
        this.childLoading = true;
        const listItem = this.SalesLeadsTypeData[3].ListData.find((x) => x.rid === param);
        const wasUnread = !!(listItem && (listItem.readDate === '9999-12-31' || listItem.ReadDate === '9999-12-31'));
        InquiryFormService.GetLikeFollowDetail({
          companyId: this.user.empCompanyId,
          rid: param,
          langId: this.langId
        })
          .then((res) => {
            // API 可能返回 object 或 array（沿用既有服务风格）
            const d = Array.isArray(res) ? (res[0] || null) : res;

            if (!d) {
              // fallback: from current list item
              const item = this.SalesLeadsTypeData[3].ListData.find(x => x.rid === param);
              this.LikeFollowDetail = item || null;
              this.recordSalesLeadView('SalesleadBack_LikeFollow', param, item);
            } else {
              let detailReadDate = d.ReadDate || d.readDate;
              // 与名片过程一致：过程先 SELECT 再 UPDATE，首包 ReadDate 可能仍为未读；成功打开详情后按已读同步列表与角标
              const unreadSentinel = '9999-12-31';
              if (!this.simulatedSupplier && wasUnread && (!detailReadDate || detailReadDate === unreadSentinel)) {
                const now = new Date();
                const y = now.getFullYear();
                const m = now.getMonth() + 1;
                const day = now.getDate();
                detailReadDate = `${y}-${m < 10 ? '0' : ''}${m}-${day < 10 ? '0' : ''}${day}`;
              }
              this.LikeFollowDetail = {
                            ...d,
                            rid: d.rid,
                            leadId: d.leadId,
                            eventCode: d.eventCode,
                            status: d.status,
                            createdAt: d.createdAt,
                            cdate: d.cdate,
                            readDate: detailReadDate,
                            buyerNameMasked: d.buyerNameMasked,
                            buyerCompanyMasked: d.buyerCompanyMasked,
                            compname: d.compname,
                            companyLogoUrl: d.companyLogoUrl,
                            countryRegion: d.countryRegion,
                            refNo: d.refNo,
                            empProductId: d.empProductId,
                            productName: d.productName,
                            productPhoto: d.productPhoto,
                            productUrl: d.productUrl,
                            jobTitle: d.jobTitle,
                            tel: d.tel,
                            email: d.email ?? d.Email,
                            product: d.product,
                            invite: d.invite,
                            contact: d.contact
              };
              this.recordSalesLeadView('SalesleadBack_LikeFollow', param, d);
              if (!this.simulatedSupplier && listItem && detailReadDate && detailReadDate !== unreadSentinel) {
                listItem.readDate = detailReadDate;
                listItem.ReadDate = detailReadDate;
                const list = this.SalesLeadsTypeData[3].ListData;
                this.SalesLeadsTypeData[3].Nums = list.filter(
                  (a) => a && (a.readDate === unreadSentinel || a.ReadDate === unreadSentinel)
                ).length;
              }
            }
            this.childLoading = false;
            this.loading = false;
          })
          .catch(() => {
            const item = this.SalesLeadsTypeData[3].ListData.find(x => x.rid === param);
            this.LikeFollowDetail = item || null;
            if (item) {
              this.recordSalesLeadView('SalesleadBack_LikeFollow', param, item);
            }
            this.childLoading = false;
            this.loading = false;
          });
      },
        updateUnreadStore() {
            this.syncAllTabBadge();
        },
        GetNameCardListFunc() {
            const that = this;
            that.beginListLoad();
            const opts = that.listQueryOptions();
            return InquiryFormService.GetNameCardList(that.user.empCompanyId, that.listFilterKeyword, opts)
                .then((res) => {
                    const parsed = that.parsePagedListResponse(res);
                    that.SalesLeadsTypeData[2].ListData = parsed.list;
                    that.listTotalCount = parsed.totalCount;
                    that.listPageIndex = parsed.pageIndex;
                    that.endListLoad();

                    // 默认不选中，让用户点击左侧列表再显示详情
                    if (that.IsNameCard) {
                        that.activeId = -1;
                        that.NameCardDetail = null;
                    }
                })
                .catch((err) => {
                    that.SalesLeadsTypeData[2].ListData = [];
                    that.listTotalCount = 0;
                    that.SalesLeadsTypeData[2].Nums = 0;
                    that.endListLoad();
                    if (that.IsNameCard) {
                        that.activeId = -1;
                        that.NameCardDetail = null;
                    }
                });
        },
        GetNameCardDetail(param) {
            this.childLoading = true;
            // 先检查列表中该项的原始 readDate 状态
            const listItem = this.SalesLeadsTypeData[2].ListData.find(x => x.rid === param);
            const wasUnread = listItem && (listItem.readDate === '9999-12-31' || listItem.ReadDate === '9999-12-31');
            
            InquiryFormService.GetNameCardDetail({ langId: this.langId, rid: param })
                .then(res => {
                    if (res && res.length) {
                        this.NameCardDetail = res[0];
                        this.recordSalesLeadView('SalesleadBack_NameCard', param, res[0]);

                        // 更新列表中的 readDate（从详情返回的数据中获取）
                        if (!this.simulatedSupplier && listItem) {
                            const detailReadDate = res[0].ReadDate || res[0].readDate;
                            if (detailReadDate) {
                                listItem.readDate = detailReadDate;
                                listItem.ReadDate = detailReadDate;
                            }
                            
                            // 如果原来是未读状态，现在已读，更新未读数
                            if (wasUnread && detailReadDate !== '9999-12-31') {
                                this.SalesLeadsTypeData[2].Nums = Math.max(0, (this.SalesLeadsTypeData[2].Nums || 0) - 1);
                                this.syncAllTabBadge();
                                this.updateUnreadStore();
                            }
                        }
                    } else {
                        const item = this.SalesLeadsTypeData[2].ListData.find(x => x.rid === param);
                        if (item) {
                            this.NameCardDetail = item;
                            this.recordSalesLeadView('SalesleadBack_NameCard', param, item);
                        }
                    }
                    this.childLoading = false;
                    this.loading = false;
                })
                .catch(() => {
                    const item = this.SalesLeadsTypeData[2].ListData.find(x => x.rid === param);
                    if (item) {
                        this.NameCardDetail = item;
                        this.recordSalesLeadView('SalesleadBack_NameCard', param, item);
                    }
                    this.childLoading = false;
                    this.loading = false;
                });
        },
        openExportModal() {
            this.exportModalVisible = true;
        },
        async onExportConfirm(options) {
            if (oplogExportHud.active) {
                this.exportQueueModalVisible = true;
                return;
            }
            this.exportModalVisible = false;
            this.exporting = true;
            const exportOptions = { ...options };
            try {
                if (exportOptions.rangeMode === 'all') {
                    const leadKeys = this.resolveExportLeadKeys();
                    const maxRows = await this.ensureSalesLeadExportMaxRowsLoaded();
                    const counts = await this.estimateExportRowCountByType(
                        leadKeys,
                        this.listFilterKeyword,
                        false,
                    );
                    const exceededKey = Object.keys(counts).find((k) => Number(counts[k] || 0) > maxRows);
                    if (exceededKey) {
                        this.exportLimitModalVisible = true;
                        return;
                    }
                }
                await runClientExportWithHud({
                    progressTitle: this.$t('lbl_EMPBE_SalesLead_Export_ProgressTitle'),
                    progressSubtitle: this.$t('lbl_EMPBE_SalesLead_Export_ProgressSubtitle'),
                    job: ({ endPreparing, hideToast }) =>
                        this.runSalesLeadExport(exportOptions, { endPreparing, hideToast }),
                });
            } catch (e) {
                this.applySalesLeadExportFailure();
            } finally {
                this.exporting = false;
            }
        },
        async estimateExportRowCountByType(leadKeys, keyword, unreadOnly) {
            const out = {};
            for (const key of leadKeys) {
                const raw = await this.fetchExportListPage(key, keyword, unreadOnly, 1, 1);
                const parsed = this.parsePagedListResponse(raw);
                out[key] = Number(parsed.totalCount) || 0;
            }
            return out;
        },
        fetchExportListPage(leadKey, keyword, unreadOnly, pageIndex, pageSize) {
            const cid = this.user.empCompanyId;
            if (leadKey === 'inquiry') {
                return InquiryFormService.GetInquiryList(cid, keyword, { pageIndex, pageSize, unreadOnly });
            }
            if (leadKey === 'nameCard') {
                return InquiryFormService.GetNameCardList(cid, keyword, { pageIndex, pageSize, unreadOnly });
            }
            if (leadKey === 'likeFollow') {
                return InquiryFormService.GetLikeFollowList(cid, keyword, { pageIndex, pageSize, unreadOnly });
            }
            if (leadKey === 'matched') {
                return InquiryFormService.GetSourcingMatching({ companyId: cid, keyword, pageIndex, pageSize, unreadOnly });
            }
            if (leadKey === 'applied') {
                return InquiryFormService.GetSourcingContactBuyer({ companyId: cid, keyword, pageIndex, pageSize, unreadOnly });
            }
            return Promise.resolve({ items: [], totalCount: 0 });
        },
        resolveExportLeadKeys() {
            if (this.IsAll) return ['inquiry', 'nameCard', 'likeFollow', 'matched', 'applied'];
            if (this.IsInquiry) return ['inquiry'];
            if (this.IsNameCard) return ['nameCard'];
            if (this.IsLikeFollow) return ['likeFollow'];
            if (this.IsMathed) return ['matched'];
            return ['applied'];
        },
        resolveExportLeadTypeParam(leadKeys) {
            return leadKeys.length > 1 ? 'all' : leadKeys[0];
        },
        isExportLimitExceeded(res) {
            const msgs = res?.msg || res?.Msg || [];
            const list = Array.isArray(msgs) ? msgs : [msgs];
            return list.some((m) => String(m).indexOf('ExportLimitExceeded') >= 0);
        },
        isExportQueue(res) {
            const code = Number(res?.statusCode ?? res?.StatusCode);
            if (code === 409 || code === 429) return true;
            const parts = [...(res?.msg || res?.Msg || []), ...(res?.systemErrorMsg || res?.SystemErrorMsg || [])]
                .map((x) => String(x || ''));
            const s = parts.join(' ').toLowerCase();
            if (!s.trim()) return false;
            const hit =
                /exportinprogress|currently exporting|other data is exporting|export.*in progress|concurrent export|請稍後再試|请稍后再试|其他數據正在導出|其他数据正在导出|已有其他.*導出|已有其他.*导出|please wait.*complete|try again later/i.test(s);
            return hit;
        },
        getExportSheetBlock(apiSheets, leadKey) {
            if (!apiSheets || leadKey == null) return null;
            if (apiSheets[leadKey]) return apiSheets[leadKey];
            const want = String(leadKey).toLowerCase();
            const found = Object.keys(apiSheets).find((k) => String(k).toLowerCase() === want);
            return found ? apiSheets[found] : null;
        },
        buildExportWorkbookSheets(exportPayload, leadKeys, sheetNames) {
            const apiSheets = exportPayload?.sheets || exportPayload?.Sheets || {};
            const defaultHeaders = exportPayload?.headers || exportPayload?.Headers || [];
            const out = [];
            leadKeys.forEach((key) => {
                const block = this.getExportSheetBlock(apiSheets, key);
                if (!block) return;
                const headers = block.headers || block.Headers || defaultHeaders;
                const rows = block.rows || block.Rows || [];
                out.push({
                    name: String(sheetNames[key] || key).slice(0, 31),
                    rows: [headers, ...rows],
                });
            });
            return out;
        },
        async runSalesLeadExport({ rangeMode, fromDate, toDate, format }, { endPreparing, hideToast } = {}) {
            const companyId = this.user.empCompanyId;
            let exportLeaseToken = null;
            const unreadOnly = false;
            const keyword = this.listFilterKeyword;
            const leadKeys = this.resolveExportLeadKeys();
            const sheetNames = {
                inquiry: this.$t('lbl_EMPBE_SalesLead_NameCardPage_EnquiriesTab'),
                nameCard: this.$t('lbl_EMPBE_SalesLead_NameCardPage_NameCardTab'),
                likeFollow: this.$t('lbl_EMPBE_SalesLead_LikeFollow'),
                matched: this.$t('lbl_EMPBE_SalesLead_MatchedForYou'),
                applied: this.$t('lbl_EMPBE_SalesLead_RepliedByYou'),
            };
            const langId = parseInt(localStorage.getItem('currentLangId'), 10) || 936;
            const leadTypeParam = this.resolveExportLeadTypeParam(leadKeys);
            let preparingEnded = false;
            try {
                const exportStatus = await InquiryFormService.GetSalesLeadExportStatus(companyId);
                if (exportStatus.exportInProgress && !exportStatus.leaseBypassActive) {
                    if (typeof endPreparing === 'function') {
                        endPreparing();
                        preparingEnded = true;
                    }
                    if (typeof hideToast === 'function') hideToast();
                    this.exportQueueModalVisible = true;
                    return;
                }
            } catch (err) {
            }
            try {
                const apiRes = await InquiryFormService.ExportSalesLeads(this.user.empCompanyId, keyword, {
                    unreadOnly,
                    leadType: leadTypeParam,
                    langId,
                    fromDate: rangeMode === 'date' ? fromDate : undefined,
                    toDate: rangeMode === 'date' ? toDate : undefined,
                });
                if (typeof endPreparing === 'function') {
                    endPreparing();
                    preparingEnded = true;
                }
                const ok = apiRes?.isSuccessful ?? apiRes?.IsSuccessful;
                if (!ok) {
                    const failMax = apiRes?.data?.maxExportRows ?? apiRes?.Data?.MaxExportRows ?? apiRes?.data?.MaxExportRows ?? apiRes?.Data?.maxExportRows;
                    if (failMax != null) this.salesLeadMaxExportRows = failMax;
                    if (typeof hideToast === 'function') hideToast();
                    if (this.isExportLimitExceeded(apiRes)) {
                        this.exportLimitModalVisible = true;
                    } else if (this.isExportQueue(apiRes)) {
                        this.exportQueueModalVisible = true;
                    } else {
                        this.applySalesLeadExportFailure(hideToast);
                    }
                    return;
                }
                const payload = apiRes.data || apiRes.Data || {};
                exportLeaseToken = payload.exportLeaseToken || payload.ExportLeaseToken || null;
                if (payload.maxExportRows ?? payload.MaxExportRows) {
                    this.salesLeadMaxExportRows = payload.maxExportRows ?? payload.MaxExportRows;
                }
                const total = Number(payload.totalCount ?? payload.TotalCount) || 0;
                const apiSheets2 = payload.sheets || payload.Sheets || {};
                const sheets = this.buildExportWorkbookSheets(payload, leadKeys, sheetNames);
                if (!sheets.length) {
                    if (typeof hideToast === 'function') hideToast();
                    this.applySalesLeadExportFailure();
                    return;
                }
                const wb = XLSX.utils.book_new();
                sheets.forEach((s) => {
                    const ws = XLSX.utils.aoa_to_sheet(s.rows);
                    XLSX.utils.book_append_sheet(wb, ws, s.name);
                });
                const ts = formatClientExportTimestamp(new Date());
                const sheetBreakdown = {};
                if (leadTypeParam === 'all') {
                    leadKeys.forEach((key) => {
                        const block = this.getExportSheetBlock(apiSheets2, key);
                        if (!block) return;
                        const rows = block.rows || block.Rows || [];
                        sheetBreakdown[key] = Array.isArray(rows) ? rows.length : 0;
                    });
                }
                const maxExportRows = payload.maxExportRows ?? payload.MaxExportRows ?? this.salesLeadMaxExportRows;
                let fileName;
                if (format === 'csv' && sheets.length === 1) {
                    fileName = `sales_leads_${ts}.csv`;
                    const csv = XLSX.utils.sheet_to_csv(XLSX.utils.aoa_to_sheet(sheets[0].rows));
                    downloadUtf8CsvFile(csv, fileName);
                } else {
                    fileName = `sales_leads_${ts}.xlsx`;
                    XLSX.writeFile(wb, fileName);
                }
                this.logSalesLeadExportToFormData({
                    leadType: leadTypeParam,
                    leadTypeLabel: this.resolveSalesLeadExportLeadTypeLabel(leadTypeParam, sheetNames),
                    rangeMode,
                    fromDate: rangeMode === 'date' ? fromDate : null,
                    toDate: rangeMode === 'date' ? toDate : null,
                    format,
                    unreadOnly,
                    keyword,
                    totalCount: total,
                    sheetBreakdown: leadTypeParam === 'all' ? sheetBreakdown : null,
                    fileName,
                    maxExportRows,
                });
            } catch (e) {
                this.applySalesLeadExportFailure(hideToast);
            } finally {
                if (!preparingEnded && typeof endPreparing === 'function') {
                    endPreparing();
                }
                if (exportLeaseToken) {
                    const t = exportLeaseToken;
                    exportLeaseToken = null;
                    InquiryFormService.ReleaseSalesLeadExportLease({
                        companyId,
                        exportLeaseToken: t,
                    }).catch(() => {});
                }
            }
        },
        updateWidth() {
            this.windowWidth = window.innerWidth || document.documentElement.clientWidth;
        }
    },
    created() {
        this.resetRemarkDirtyState();
        this.ChangeTabByRoute();
        this.GetSysCompanySponsorType();
        // keep provider in sync for cases where permissionData is already available
        this.permissionDataProvider.value = this.permissionData;
        const vm = this;
        this.mainTabsSwiperOptions = {
            ...this.mainTabsSwiperOptions,
            on: {
                init() {
                    vm.$nextTick(() => vm.bindSalesLeadMainTabsNavigation());
                },
            },
        };
    },
    mounted() {
        this.init();
        this.$nextTick(() => {
            this.bindSalesLeadMainTabsNavigation();
        });
    },
    async beforeRouteLeave(to, from, next) {
        const canLeave = await this.confirmLeaveIfRemarkDirty();
        if (canLeave) {
            next();
        }
    },
}

</script>
<style lang="scss" scoped>
.search-result-container {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 800;
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
}
</style>
<style lang="scss">
@media screen and (max-width: 480px) {
    /* 手机：左右 16px 与 Figma 一致；底部预留 Safari 工具栏 + 安全区 */
    .sales-lead-page {
        --sl-mobile-side: 16px;
        --sl-mobile-bottom-safe: max(88px, calc(env(safe-area-inset-bottom, 0px) + 72px));
        --sl-mobile-stack-gap: 8px;
        --sl-mobile-section-gap: 12px;
        --sl-mobile-card-radius: 16px;
    }

    /* 手机：不用桌面 fixed 左栏，恢复整列全宽布局 */
    .sales-lead-page .sales-lead {
        flex-direction: column;
        align-items: stretch;
        padding-left: 0 !important;
        min-height: 0 !important;
        width: 100%;
        max-width: 100%;
    }

    .sales-lead-page .sales-lead-left {
        position: static !important;
        top: auto !important;
        left: auto !important;
        width: 100% !important;
        max-width: 100% !important;
        flex: none !important;
        z-index: auto !important;
    }

    .sales-lead-page .leftmenu {
        width: 100% !important;
        max-width: 100% !important;
        height: 90vh;
        max-height: none;
        align-self: stretch;
        padding: 12px var(--sl-mobile-side) !important;
        border-radius: 0 !important;
        box-shadow: none !important;
    }

    .sales-lead-page .sales-lead-visitor {
        width: 100% !important;
        min-width: 0 !important;
        min-height: 0 !important;
        flex: 1 1 auto !important;
    }

    .sales-lead-page .sales-lead-visitor > .b-overlay,
    .sales-lead-page .sales-lead-visitor .b-overlay-wrap {
        min-height: 0 !important;
        display: block !important;
    }

    .sales-lead-page .sales-lead-empty {
        min-height: 0 !important;
        min-width: 0 !important;
        width: 100% !important;
    }

    /* 侧栏常挂到 body，变量必须写在侧栏自身（不能依赖 .sales-lead-page） */
    #sidebar-productinquiry.b-sidebar,
    #sidebar-productinquiry.sales-lead-mobile-sidebar {
        --sl-mobile-side: 16px;
        --sl-mobile-bottom-safe: max(88px, calc(env(safe-area-inset-bottom, 0px) + 72px));
        --sl-mobile-stack-gap: 8px;
        --sl-mobile-section-gap: 12px;
        --sl-mobile-card-radius: 16px;
        top: var(--emp-mobile-header-height, 65px) !important;
        left: 0 !important;
        right: 0 !important;
        width: 100vw !important;
        max-width: 100vw !important;
        height: calc(100dvh - var(--emp-mobile-header-height, 65px)) !important;
        max-height: calc(100dvh - var(--emp-mobile-header-height, 65px)) !important;
        margin-top: 0 !important;
        padding: 0 !important;
        overflow: hidden;
        box-sizing: border-box;
        z-index: 1050 !important;
        background: #f8f8f8 !important;
    }

    #sidebar-productinquiry .b-sidebar-body {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        background: #f8f8f8;
        padding-left: var(--sl-mobile-side, 16px);
        padding-right: var(--sl-mobile-side, 16px);
        padding-bottom: var(--sl-mobile-bottom-safe, 88px);
        scroll-padding-bottom: var(--sl-mobile-bottom-safe, 88px);
        box-sizing: border-box;
    }

    .b-sidebar-backdrop {
        top: var(--emp-mobile-header-height, 65px) !important;
        height: calc(100dvh - var(--emp-mobile-header-height, 65px)) !important;
        z-index: 1040 !important;
    }

    /* 手机详情：外层（灰底返回+标题）z-index 高于内层（白卡片） */
    #sidebar-productinquiry .lf-container,
    #sidebar-productinquiry .enquiry-container,
    #sidebar-productinquiry .productSourcingMatched-container {
        gap: var(--sl-mobile-section-gap);
    }

    #sidebar-productinquiry .nc-mobile.nc-tray,
    #sidebar-productinquiry .lf-mobile.lf-tray,
    #sidebar-productinquiry .enquiry-container .enquiry-detail,
    #sidebar-productinquiry .productSourcingMatched-container .productSourcingMatched-detail {
        background: transparent !important;
        box-shadow: none !important;
        border-radius: 0 !important;
        padding: 0 !important;
        gap: var(--sl-mobile-stack-gap);
    }

    #sidebar-productinquiry .nc-mobile.nc-tray,
    #sidebar-productinquiry .lf-mobile.lf-tray {
        padding: 0 !important;
    }

    /* 外层：返回+标题（左右留白由 .b-sidebar-body padding 统一控制） */
    #sidebar-productinquiry .enquiry-header-container,
    #sidebar-productinquiry .nc-title-row,
    #sidebar-productinquiry .lf-title-row,
    #sidebar-productinquiry .productSourcingMatched-header-container {
        position: relative;
        z-index: 1;
        background: #f8f8f8;
        padding: 12px 0 8px;
        margin-bottom: 0;
    }

    #sidebar-productinquiry .lf-title-row {
        flex-direction: column;
        align-items: stretch;
    }

    #sidebar-productinquiry .lf-title-left {
        width: 100%;
        flex: 0 0 auto;
    }

    #sidebar-productinquiry .lf-title-right {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    #sidebar-productinquiry .lf-title-text {
        width: 100%;
        overflow-wrap: break-word;
        word-break: break-word;
    }

    /* 内层：灰底上分块白卡片（左右留白由 --sl-mobile-side 控制） */
    #sidebar-productinquiry .nc-mobile .nc-content,
    #sidebar-productinquiry .lf-mobile .lf-content {
        position: relative;
        z-index: 1;
        background: transparent !important;
        box-shadow: none !important;
        border-radius: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        box-sizing: border-box;
        width: auto;
        max-width: none;
    }

    #sidebar-productinquiry .nc-mobile .nc-section,
    #sidebar-productinquiry .nc-mobile .nc-contact,
    #sidebar-productinquiry .nc-section--remarks,
    #sidebar-productinquiry .lf-mobile .lf-section,
    #sidebar-productinquiry .lf-mobile .lf-contact,
    #sidebar-productinquiry .lf-mobile .lf-hint {
        margin-bottom: var(--sl-mobile-stack-gap, 8px);
        box-sizing: border-box;
        width: 100%;
        max-width: 100%;
    }

    #sidebar-productinquiry .enquiry-unLock,
    #sidebar-productinquiry .enquiry-body-container,
    #sidebar-productinquiry .productSourcingMatched-body-container {
        position: relative;
        z-index: 1;
        background: #fff;
        border-radius: var(--sl-mobile-card-radius, 16px);
        box-shadow: 0 2px 15px 0 rgba(183, 183, 183, 0.3);
        padding: 16px;
        margin: 0 0 var(--sl-mobile-stack-gap, 8px);
        box-sizing: border-box;
        width: 100%;
        max-width: 100%;
    }

    /* 仅名片 / 点赞关注：白卡浮动阴影 */
    #sidebar-productinquiry .nc-mobile .nc-card:not(.nc-message-board-card),
    #sidebar-productinquiry .nc-mobile .nc-unLock,
    #sidebar-productinquiry .nc-section--remarks .message-thread,
    #sidebar-productinquiry .lf-mobile .lf-card,
    #sidebar-productinquiry .lf-mobile .lf-unlock,
    #sidebar-productinquiry .lf-remarks .message-thread {
        box-shadow: 0 2px 15px 0 rgba(183, 183, 183, 0.3);
    }

    #sidebar-productinquiry .lf-mobile .lf-hint {
        border-radius: 8px;
        margin-bottom: var(--sl-mobile-stack-gap, 8px);
    }

    /* Remarks：外层透明；左右留白与分块卡片一致（nc-section--remarks 用 margin，其余用 padding） */
    #sidebar-productinquiry .enquiry-remarks,
    #sidebar-productinquiry .lf-remarks,
    #sidebar-productinquiry .productSourcingMatched-remarks,
    #sidebar-productinquiry .nc-message-board-card {
        position: relative;
        z-index: 1;
        width: 100%;
        box-sizing: border-box;
        background: transparent !important;
        box-shadow: none !important;
        border-radius: 0 !important;
        margin: 0 0 var(--sl-mobile-stack-gap) !important;
    }

    #sidebar-productinquiry .enquiry-remarks,
    #sidebar-productinquiry .lf-remarks,
    #sidebar-productinquiry .productSourcingMatched-remarks {
        padding: 0 !important;
    }

    #sidebar-productinquiry .message-thread {
        margin: 0;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        gap: var(--sl-mobile-section-gap);
        padding: 12px 16px 16px;
        border-radius: var(--sl-mobile-card-radius);
    }

    #sidebar-productinquiry .message-thread__list {
        gap: var(--sl-mobile-stack-gap);
    }

    #sidebar-productinquiry .message-composer {
        gap: var(--sl-mobile-stack-gap);
        padding-bottom: env(safe-area-inset-bottom, 0px);
    }

    #sidebar-productinquiry .message-composer__editor {
        padding-bottom: 52px;
    }

    #sidebar-productinquiry .enquiry-unLock,
    #sidebar-productinquiry .nc-mobile .nc-unLock,
    #sidebar-productinquiry .lf-mobile .lf-unlock {
        padding: 12px 16px;
    }

    #sidebar-productinquiry .nc-section--remarks {
        margin-bottom: 0;
    }

    .sales-lead {
        justify-content: stretch;
    }

    .sales-lead-page > .container-fluid {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
}

@media screen and (min-width: 481px) {
    /* router 过渡在 .view 上的 transform 会使 fixed 失效（仅桌面） */
    .view:has(.sales-lead-page) {
        transform: none !important;
    }

    /* 左侧 fixed 在内容区外侧；整页只有 window 一条滚动条（右侧随页滚） */
    .sales-lead-page {
        --sl-left-col-width: 400px;
        --sl-col-gap: 16px;
        /* 与 .page-body padding: 32px 对齐（原先 +48 会吃掉 16px 间距） */
        --sl-content-offset-x: calc(222px + 32px);
    }

    .page-wrapper.compact-wrapper:has(.sidebar-wrapper.close_icon) .sales-lead-page {
        --sl-content-offset-x: calc(90px + 32px);
    }

    .sales-lead-page .sales-lead {
        padding-left: calc(var(--sl-left-col-width) + var(--sl-col-gap));
        /* 左侧 fixed 不占文档流高度，需显式撑开右侧占位区 */
        min-height: 75vh;
    }

    .sales-lead-left {
        position: fixed;
        top: var(--sl-sticky-top);
        left: var(--sl-content-offset-x);
        width: var(--sl-left-col-width);
        max-width: 890px;
        z-index: 6;
    }

    .sales-lead .leftmenu {
        width: 100%;
        height: 75vh;
        max-height: 75vh;
    }

    .sales-lead-page .sales-lead-visitor .b-overlay-wrap,
    .sales-lead-page .sales-lead-visitor .b-overlay {
        overflow: visible !important;
    }

    .sales-lead-visitor {
        min-height: 75vh;
        align-self: stretch;
    }

    .sales-lead-visitor > .b-overlay {
        min-height: 75vh;
        display: flex;
        flex-direction: column;
    }

    .sales-lead-visitor .b-overlay-wrap:has(.sales-lead-empty) {
        flex: 1 1 auto;
        min-height: 75vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .sales-lead-empty {
        flex: 1 1 auto;
        width: 100%;
        min-height: 75vh;
        align-self: stretch;
    }

    .sales-lead-page .sales-lead--embedded .sales-lead-left {
        position: sticky !important;
        top: var(--sl-sticky-top) !important;
        left: auto !important;
        z-index: 6;
    }

    #supplier .sales-lead-page > .container-fluid,
    #supplier-sidebar .sales-lead-page > .container-fluid {
        padding-left: 12px;
        padding-right: 12px;
    }
}

.no-enquiry {
    display: flex;
    padding: 8px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    align-self: stretch;

    .upper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        align-self: stretch;

        .no-enquiry-svg-container {
            display: flex;
            width: 64px;
            height: 64px;
            padding: 6.667px 0.095px 6.6px 0px;
            justify-content: center;
            align-items: center;

            .no-enquiry-svg {
                width: 63.905px;
                height: 50.733px;
                flex-shrink: 0;
            }
        }

        .no-enquiry-text {
            align-self: stretch;
            color: var(--on-surface-50, rgba(0, 0, 0, 0.50));
            text-align: center;
            font-feature-settings: 'liga' off, 'clig' off;
            font-size: 13px;
            font-style: normal;
            font-weight: 500;
            line-height: 150%;
            /* 21px */
        }
    }

    .no-enquiry-desc {
        color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        /* 19.5px */
        letter-spacing: 0.15px;
    }
}

.no-search-result {
    display: flex;
    padding: 8px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;

    .no-search-result-svg {
        width: 64px;
        height: 64px;
    }

    .no-search-result-text {
        align-self: stretch;
        color: var(--on-surface-50, rgba(0, 0, 0, 0.50));
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        /* 21px */
    }
}

/* Name Card empty state (Figma node 3133:26197) */
.nc-empty {
    display: flex;
    padding: 8px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}

.nc-empty-icon {
    width: 64px;
    height: 64px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.nc-empty-text {
    align-self: stretch;
    color: var(--on-surface-50, rgba(0, 0, 0, 0.50));
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}

/* 顶栏 32px + page-body 上内边距 40px + 间距 */
.sales-lead-page {
    --emp-header-height: 32px;
    --sl-sticky-gap: 16px;
    --sl-sticky-top: calc(var(--emp-header-height) + 16px + var(--sl-sticky-gap));
}

.sales-lead {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    margin-bottom: 16px;
}

.sales-lead-visitor {
    flex: 1 1 0;
    min-width: 300px;
    min-height: 0;
    align-self: stretch;
}

.sales-lead--embedded {
    --sl-left-col-width: 400px;
    --sl-sticky-top: 75px;
    flex-direction: row !important;
    flex-wrap: nowrap;
    align-items: flex-start !important;
    padding-left: 0 !important;
}

.sales-lead-visitor--admin {
    flex: 1 1 0;
    min-width: 0;
    max-width: calc(100% - var(--sl-left-col-width) - 16px);
    align-self: stretch;
}

#supplier .sales-lead-visitor--admin .sales-lead-detail,
#supplier .sales-lead-visitor--admin .sales-lead-empty {
    min-width: 0;
    max-width: 100%;
    width: 100%;
}

#supplier .sales-lead-visitor--admin .enquiry-title-name,
#supplier .sales-lead-visitor--admin .enquiry-body-right-body-info-detail,
#supplier .sales-lead-visitor--admin .enquiry-body-left-requirment-detail,
#supplier .sales-lead-visitor--admin .nc-title-text,
#supplier .sales-lead-visitor--admin .lf-title-text {
    min-width: 0;
    max-width: 100%;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.sales-lead-page .sales-lead--embedded .sales-lead-left {
    width: var(--sl-left-col-width) !important;
    max-width: min(100%, var(--sl-left-col-width)) !important;
    flex: 0 0 auto !important;
    min-width: 0;
}

.sales-lead-page .sales-lead--embedded .leftmenu {
    width: 100% !important;
    max-width: var(--sl-left-col-width) !important;
    min-width: 0;
}

.sales-lead-page .sales-lead--embedded .leftmenu__body-scroll,
.sales-lead-page .sales-lead--embedded .search,
.sales-lead-page .sales-lead--embedded .HoverStyle {
    min-width: 0;
    max-width: 100%;
}

#supplier .supplierDetailTabs .tab-pane .sales-lead-page {
    overflow-x: visible;
}

.sales-lead-page .sales-lead--embedded .leftmenu .header,
.sales-lead-page .sales-lead--embedded .main-tabs-slider-wrap {
    overflow: visible;
}

.sales-lead-empty {
    flex: 1 1 0;
    min-width: 300px;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    container-type: inline-size;
}

.sales-lead-detail {
    flex: 1 1 0;
    align-self: flex-start;
    min-width: 300px;
    min-height: 0;
    container-type: inline-size;
    width: 100%;
    border-radius: 24px;
}

.HoverStyle {
    background: var(--Surface, #FFF);
    border-radius: 8px;   
     overflow: hidden;
}

.HoverStyle:hover {
    background: var(--on-surface-3, rgba(0, 0, 0, 0.03));
    border-radius: 8px !important;  
}

.leftmenu {
    display: flex;
    width: 400px;
    max-width: 890px;
    padding: 24px;
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
    align-self: flex-start;
    flex-shrink: 0;
    border-radius: 24px;
    background: var(--Surface, #FFF);
    box-shadow: 0px 2px 15px 0px rgba(183, 183, 183, 0.30);
    overflow: visible;
    min-height: 0;
    max-height: 75vh;
    box-sizing: border-box;

    .leftmenu__skeleton {
        flex: 1 1 0;
        min-height: 0;
        overflow-y: auto;
        align-self: stretch;
    }

    .leftmenu__list-host {
        position: relative;
        flex: 1 1 0;
        min-height: 0;
        align-self: stretch;
        width: 100%;
    }

    .leftmenu__list-host--refreshing .search,
    .leftmenu__list-host--refreshing .nc-empty,
    .leftmenu__list-host--refreshing .no-enquiry,
    .leftmenu__list-host--refreshing .no-search-result {
        opacity: 0.4;
        pointer-events: none;
    }

    .leftmenu__skeleton--overlay {
        position: absolute;
        inset: 0;
        z-index: 2;
        flex: none;
        min-height: 100%;
        background: rgba(255, 255, 255, 0.78);
        pointer-events: none;
    }

    .leftmenu__body-scroll {
        flex: 1 1 0;
        min-height: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-self: stretch;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        scrollbar-gutter: stable;
        padding-right: 4px;
        box-sizing: border-box;
    }

    /* 与 .search-item-container padding 一致，分页首钮左缘对齐列表图标左缘 */
    --sl-list-row-inset-x: 12px;

    /* Figma：列表与分页 16px = gap 8px + footer 额外 8px；底边 24px 由 padding 承担 */
    .leftmenu__footer {
        align-self: stretch;
        flex-shrink: 0;
        margin-top: 8px;
        padding: 0 0 0 var(--sl-list-row-inset-x);
        overflow: visible;
        min-width: 0;
        width: 100%;
        box-sizing: border-box;
    }

    .header {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        z-index: 3;

        .header-title-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            align-self: stretch;
            min-width: 0;
        }

        .title {
            flex: 1 1 auto;
            min-width: 0;
            color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%;
            /* 30px */
            letter-spacing: -0.22px;
        }

        .main-tabs-swipe-hint {
            flex-shrink: 0;
            display: inline-flex;
            align-items: center;
            gap: 2px;
            padding: 4px 8px 4px 10px;
            border: none;
            border-radius: 999px;
            background: rgba(0, 0, 0, 0.05);
            color: rgba(0, 0, 0, 0.45);
            font-size: 12px;
            font-weight: 400;
            line-height: 150%;
            cursor: pointer;
            transition: background 0.2s, color 0.2s;

            &:hover,
            &:focus-visible {
                background: rgba(0, 0, 0, 0.08);
                color: rgba(0, 0, 0, 0.65);
                outline: none;
            }

            .main-tabs-swipe-hint__text {
                white-space: nowrap;
            }

            .main-tabs-swipe-hint__icon {
                flex-shrink: 0;
                display: block;
            }
        }

        /* 对齐 BuyerHeader_IndustryNews：相对定位 + 悬浮显示 navigation 圆钮 */
        .main-tabs-slider-wrap {
            position: relative;
            align-self: stretch;
            min-width: 0;
        }

        .main-tabs-slider-wrap:hover .sl-main-tabs-nav-btn {
            display: flex;
        }

        .sl-main-tabs-nav-btn {
            display: none;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 5;
            margin-top: 0;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            cursor: pointer;
            background-color: rgba(255, 255, 255, 0.95);
            border: 1px solid #ddd;
            align-items: center;
            justify-content: center;
            padding: 0.25rem;
            transition: filter 0.3s, background-color 0.3s;
            pointer-events: none;
        }

        .sl-main-tabs-nav-btn:hover {
            pointer-events: auto;
            background-color: rgba(255, 255, 255, 1);
            filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.5));
        }

        .sl-main-tabs-nav-btn::after {
            display: none !important;
        }

        .sl-main-tabs-nav-btn img {
            display: block;
            width: 18px;
            height: 18px;
            object-fit: contain;
        }

        .sl-main-tabs-nav-btn--prev {
            left: 4px;
            right: auto;
        }

        .sl-main-tabs-nav-btn--next {
            right: 4px;
            left: auto;
        }

        .main-tabs-slider-wrap:hover .sl-main-tabs-nav-btn.swiper-button-disabled {
            display: none;
        }
    }

    .OnlyShowRepyto {
        color: var(--on-surface-50, rgba(0, 0, 0, 0.50));
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        width: 100%;
        line-height: 150%;
        /* 21px */
    }
    .SalesLeadFreeGuota{
        
        width: 100%;
    }

    .tab-container {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;

        a,
        a:hover,
        a:focus,
        a:active {
            text-decoration: none;
        }

        .bg-Blur {
            background: #7366FF !important;
        }

        .bg-white {
            background: #FFF;
        }

        .Text-Blur {
            color: #7366FF;
        }

        .Text-white {
            color: #FFF;
        }
        .current-tab-inner:hover {
            background: var(--on-surface-3, rgba(0, 0, 0, 0.03));
            border-radius: 999px;
        }
        .current-tab {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            border-radius: 999px;

            .current-tab-inner {
                padding: 8px 8px 8px 10px;
                display: flex;
                align-items: center;
                gap: 4px;

                .main-tab-icon {
                    flex-shrink: 0;
                    width: 16px;
                    height: 16px;
                    object-fit: contain;
                }

                .sl-free-tips {
                    color: #FFF;
                    font-feature-settings: 'liga' off, 'clig' off;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 150%;
                    display: inline-flex;
                    padding: 2px 8px;
                    align-items: center;
                    border-radius: 4px;
                    background: linear-gradient(90deg, #CB242B 0%, #7128E8 100%),
                        radial-gradient(708.4% 271.29% at 27.34% -79.5%, #BE2A39 0%, #350091 100%),
                        radial-gradient(1543.54% 569.8% at 0% -195.45%, #FF3A3A 0%, #5E0101 100%);
                    white-space: nowrap;
                }

                .current-tab-inner-white {
                    color: #FFF;
                }

                .current-tab-inner-black {
                    color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                }

                span {
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 150%;
                    /* 21px */
                    letter-spacing: -0.154px;
                }

                .unread-num {
                    display: flex;
                    min-width: 20px;
                    max-width: 42.5px;
                    padding: 0px 5px;
                    justify-content: center;
                    align-items: center;
                    border-radius: 125px;

                    text-align: center;
                    font-family: Roboto;
                    font-size: 13.75px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 20px;
                    /* 145.455% */
                }
            }

        }
    }

    /* 顶部主 Tab Swiper：让 slide 宽度自适应内容 */
    .main-tabs-swiper {
        cursor: grab;
        touch-action: pan-x;
        
        padding-left: 4px;
        padding-right: 40px;
        box-sizing: border-box;

        &:active {
            cursor: grabbing;
        }

        .swiper-wrapper {
            align-items: flex-start;
            justify-content: flex-start;
            backface-visibility: hidden;
        }
        .swiper-slide {
            width: auto !important;
        }
    }

}

.searchbar {
    display: flex;
    padding: 8px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid var(--outline-10, rgba(0, 0, 0, 0.10));
    background: var(--Surface, #FFF);

    &:focus-within {
        border: 1px solid var(--primary-supplier-backend, #7366FF);
    }

    input {
        border: 0;
        flex: 1 0 0;
        color: var(--on-surface-50, rgba(0, 0, 0, 0.80));
        font-feature-settings: 'liga' off, 'clig' off;

        /* Text/Paragraph 2 */

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        /* 21px */
        letter-spacing: 0.15px;

        &::placeholder {
            color: var(--on-surface-50, rgba(0, 0, 0, 0.50));
        }
    }

    i {
        cursor: pointer;
        width: 20px;
        height: 20px;
    }

}

.search {
    flex: 0 0 auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
</style>